import type { MessageKey } from './en';
import { en } from './en';

export const he: Record<MessageKey, string> = {
  'language.switchTo': 'עבור ל{language}',
  'language.english': 'אנגלית',
  'language.hebrew': 'עברית',
  'language.pickerLabel': 'שפה',
  'language.toggleShortcutHint': 'החלפת שפה (Alt+Shift+L)',

  'common.back': '→ חזרה',
  'common.clear': 'נקה',
  'common.showFullDetails': 'הצג פרטים מלאים',
  'common.hideFullDetails': 'הסתר פרטים מלאים',
  'common.cancel': 'ביטול',
  'common.close': 'סגור',
  'common.delete': 'מחק',
  'common.update': 'עדכן',
  'common.display': 'הצג',
  'common.fetch': 'טען',
  'common.create': 'צור',
  'common.submit': 'שלח',
  'common.submitting': 'שולח…',
  'common.loading': 'טוען…',

  'splash.tagline': 'ONE APP. ANY SPACE.',
  'splash.brandAlt': 'Placy — אפליקציה אחת. כל מרחב.',
  'splash.progress': '{percent}% ..שווה לכם לחכות',

  'common.guest': 'אורח',
  'common.comingSoon': '(בקרוב)',
  'common.required': 'שדה חובה',
  'common.yes': 'כן',
  'common.no': 'לא',
  'common.operation': 'פעולה',
  'common.month': 'חודש',
  'common.day': 'יום',
  'common.year': 'שנה',
  'common.qty': 'כמות',
  'common.moreInfo': 'מידע נוסף',
  'common.thingsToCheck': 'דברים לבדיקה',
  'common.request': 'בקשה:',
  'common.message': 'הודעה:',
  'common.emptyAll': 'רוקן את כל השדות, נקה את התגובה והסר שגיאות',
  'common.resetPanel': 'איפוס שדות וניקוי תגובה',
  'common.signInRequired': 'נדרשת התחברות',
  'common.somethingWrong': 'משהו השתבש.',
  'common.technicalDetails': 'פרטים טכניים',
  'common.showFields': 'הצג שדות',
  'common.hideFields': 'הסתר שדות',
  'common.showInputFields': 'הצג שדות קלט',
  'common.hideInputFields': 'הסתר שדות קלט',
  'common.clearIdentifierPassword': 'נקה מזהה וסיסמה',
  'common.rawJson': 'JSON גולמי',

  'nav.main': 'ניווט ראשי',
  'nav.home': 'בית',
  'nav.bookings': 'הזמנות',
  'nav.assets': 'נכסים',
  'nav.favorites': 'מועדפים',
  'nav.messages': 'הודעות',
  'nav.messagesUnread': 'הודעות, {count} שלא נקראו',
  'nav.profile': 'פרופיל',
  'nav.contact': 'צור קשר',
  'nav.download': 'הורדת האפליקציה',
  'nav.downloadClose': 'סגור אפשרויות התקנה',
  'nav.installTitle': 'הוספה למסך הבית',
  'nav.installNow': 'התקנת האפליקציה',
  'nav.installDone': 'האפליקציה כבר נמצאת במסך הבית.',
  'nav.installIosStep1': 'פתחו את האתר בדפדפן Safari.',
  'nav.installIosStep2': 'הקישו על כפתור השיתוף.',
  'nav.installIosStep3': 'בחרו ״הוספה למסך הבית״.',
  'nav.installAndroidStep1': 'פתחו את תפריט הדפדפן (⋮).',
  'nav.installAndroidStep2': 'בחרו ״התקנת אפליקציה״ או ״הוספה למסך הבית״.',
  'nav.installDesktopHint': 'פתחו את האתר בדפדפן של הטלפון כדי להוסיף אותו למסך הבית.',
  'nav.advertiseSoon': 'פרסום (בקרוב)',
  'nav.leavePayment': 'לעזוב את התשלום? ההזמנה לא תושלם.',

  'messages.title': 'הודעות',
  'messages.loading': 'טוען שיחות…',
  'messages.empty': 'אין שיחות עדיין. כשמישהו ישלח לכם הודעה, היא תופיע כאן.',
  'messages.loadFailed': 'לא ניתן לטעון שיחות.',
  'messages.unknownPeer': 'משתמש',
  'messages.noMessagesYet': 'אין הודעות עדיין',
  'messages.unreadCount': '{count} שלא נקראו',
  'messages.backToInbox': 'חזרה לתיבת הדואר',
  'messages.loadingThread': 'טוען הודעות…',
  'messages.threadLoadFailed': 'לא ניתן לטעון הודעות.',
  'messages.composerPlaceholder': 'כתבו הודעה…',
  'messages.send': 'שליחה',
  'messages.sendFailed': 'לא ניתן לשלוח את ההודעה.',
  'messages.startFailed': 'לא ניתן לפתוח שיחה.',
  'messages.new': 'הודעה חדשה',
  'messages.newTitle': 'הודעה חדשה',
  'messages.newHint': 'בחרו נמען, כתבו הודעה, ושלחו.',
  'messages.pickRecipient': 'אל',
  'messages.searchPeople': 'חיפוש אנשים…',
  'messages.noContacts': 'אין אנשים לשלוח אליהם הודעה עדיין. פתחו סטוריז כדי למצוא אנשים.',
  'messages.messagingWith': 'שליחה אל {name}',
  'messages.unreadSection': 'הודעות חדשות',
  'messages.earlierSection': 'מוקדם יותר',

  'header.searchSoon': 'חיפוש (בקרוב)',
  'header.searchTitle': 'חיפוש נכסים',
  'header.searchLabel': 'מילת חיפוש',
  'header.searchPlaceholder': 'שם, כתובת או תיאור…',
  'header.searchPrompt': 'הקלידו שם, כתובת או תיאור כדי למצוא נכסים.',
  'header.searchMinLength': 'הקלידו לפחות 3 תווים לחיפוש.',
  'header.searchLoading': 'טוען נכסים…',
  'header.searchNoResults': 'לא נמצאו נכסים התואמים לחיפוש.',
  'header.searchSubmit': 'חיפוש',
  'assistant.fab.label': 'פתח עוזר קולי',
  'assistant.panel.title': 'עוזר Placy',
  'assistant.panel.close': 'סגור עוזר',
  'assistant.panel.empty': 'אמרו או הקלידו פקודה כדי להתחיל.',
  'assistant.panel.inputLabel': 'פקודת עוזר',
  'assistant.panel.send': 'שלח',
  'assistant.panel.newSearch': 'חיפוש חדש',
  'assistant.panel.clear': 'נקה',
  'assistant.panel.thinking': 'חושב…',
  'assistant.panel.speakOn': 'הפעל תשובות קוליות',
  'assistant.panel.speakOff': 'כבה תשובות קוליות',
  'assistant.panel.speakUnsupported': 'תשובות קוליות אינן זמינות במכשיר הזה.',
  'assistant.voice.start': 'התחל חיפוש קולי',
  'assistant.voice.stop': 'עצור האזנה',
  'assistant.voice.listening': 'מאזין…',
  'assistant.voice.hint': 'הקישו על המיקרופון ודברו (עד 8 שניות). אפשר לערוך את מילת החיפוש אחר כך.',
  'assistant.voice.editable': 'אפשר לערוך את מילת החיפוש לפני עדכון התוצאות.',
  'assistant.voice.greeting': 'איך אפשר לעזור לך, {name}?',
  'assistant.voice.greetingAnonymous': 'איך אפשר לעזור לך?',
  'assistant.voice.typeOpenSpace': 'עמדות אופן ספייס',
  'assistant.voice.actionSearchTypeCity': 'מחפש עבורך {type} ב{city}',
  'assistant.voice.actionSearchType': 'מחפש עבורך {type}',
  'assistant.voice.actionSearchCity': 'מחפש עבורך נכסים ב{city}',
  'assistant.voice.actionSearch': 'מחפש עבורך „{q}”',
  'assistant.voice.actionSearchTypeSlot': 'מחפש עבורך {type}. {chip}',
  'assistant.voice.actionSearchSlot': 'מחפש עבורך. {chip}',
  'assistant.voice.actionRefine': 'מצמצם עבורך את התוצאות',
  'assistant.voice.unsupported':
    'קלט קולי אינו זמין במכשיר הזה. ודאו שהקלדה קולית של Google (Speech Services by Google) מותקנת ומופעלת, או הקלידו את החיפוש.',
  'assistant.voice.denied':
    'הגישה למיקרופון נדחתה. אשרו את המיקרופון כש־Placy מבקשת, ואז נסו שוב.',
  'assistant.voice.empty': 'לא הקלטנו את זה. נסו שוב או הקלידו את החיפוש.',
  'assistant.voice.error': 'שגיאת קול: {code}',
  'assistant.result.search': 'מחפש „{q}”.',
  'assistant.result.searchTypeCity': 'מחפש {type} ב{city}…',
  'assistant.result.searchType': 'מחפש {type}…',
  'assistant.result.searchCity': 'מחפש ב{city}…',
  'assistant.result.browseType': 'פותח רשימת {type}.',
  'assistant.result.searchSlot': '{chip}',
  'assistant.result.searchTypeSlot': 'מחפש {type}. {chip}',
  'assistant.result.refine': 'מצמצם את התוצאות הנוכחיות. {chip}',
  'assistant.result.noMatch': 'לא נמצאו נכסים שמתאימים לחיפוש.',
  'assistant.result.foundCount': 'נמצאו {count} נכסים.',
  'assistant.result.foundCountOne': 'נמצא נכס אחד.',
  'assistant.result.cheapest': 'הזול ביותר הוא {name} — {price}. התוצאות ממוינות מהזול ליקר.',
  'assistant.result.mostExpensive': 'היקר ביותר הוא {name} — {price}. התוצאות ממוינות מהיקר לזול.',
  'assistant.result.priceSortNoPrice': 'מיינתי את התוצאות לפי מחיר, אבל לאף אחת מהן לא מופיע מחיר.',
  'assistant.result.closestToStreet':
    'הכי קרוב ל{street} הוא {name} — {distance}. התוצאות ממוינות לפי מרחק לרחוב.',
  'assistant.result.proximityNoGeo':
    'לא הצלחתי למקם את הרחוב על המפה, ולכן השארתי את התוצאות בלי מיון לפי מרחק.',
  'assistant.slot.chipAria': 'זמן ומקום מבוקשים: {chip}',
  'assistant.result.navigate': 'פותח את {target}.',
  'assistant.result.clearFavorites': 'הוסרו {count} מועדפים.',
  'assistant.result.clearFavoritesEmpty': 'אין מועדפים למחיקה.',
  'assistant.result.favoritesSearchEmpty':
    'עדיין אין מועדפים שמורים. לחצו על הלב בנכס כדי לשמור, ואז נסו שוב.',
  'assistant.result.bookConfirmPrompt':
    'מוכן לפתוח הזמנה עבור {q}. אשרו כדי להמשיך — עדיין לא מחייבים.',
  'assistant.result.bookOpened': 'פותח הזמנה. בדקו תאריכים ושלמו רק אחרי אישור במסך ההזמנה.',
  'assistant.result.bookSearchFirst': 'מחפש „{q}” כדי שתבחר/י נכס ואז תזמין/י.',
  'assistant.result.bookCancelled': 'ההזמנה בוטלה.',
  'assistant.book.currentAsset': 'הנכס הנוכחי',
  'assistant.book.confirmAria': 'אישור סיוע להזמנה',
  'assistant.book.confirmText': 'לפתוח את מסך ההזמנה עם טיוטה? התשלום עדיין דורש אישור שלכם.',
  'assistant.book.confirm': 'כן, פתח הזמנה',
  'assistant.book.cancel': 'ביטול',
  'assistant.error.unknown': 'לא הבנתי את הבקשה. נסו חיפוש, ניווט, או שאלת עזרה.',
  'assistant.error.bookNeedsConfirm': 'הזמנה דורשת אישור במסך.',
  'assistant.error.bookNeedsLogin': 'יש להתחבר כדי להמשיך להזמנה.',
  'assistant.error.bookNoAsset': 'פתחו נכס קודם, או אמרו „הזמן” עם שם לחיפוש.',
  'assistant.clarify.citySuggestions':
    'שמעתי „{heard}”. התכוונתם ל{options}? אמרו את שם העיר כדי להמשיך.',
  'assistant.clarify.streetOrCity':
    'שמעתי „{heard}”. זה שם עיר או שם רחוב? אם זו עיר, נסו למשל {options}.',
  'assistant.faq.businessLounge':
    'טרקלין עסקים הוא מרחב גמיש לפגישות ועבודה קלה — סננו לפי Business Lounge או חפשו „טרקלין עסקים”.',
  'assistant.faq.becomeOwner':
    'כדי להציע מקומות, הירשמו כבעלי נכס מפורטל ההתחברות, ואז השתמשו ב„נכסים” ליצירת מודעות עם תמונות, מחירים ושעות.',
  'assistant.faq.howBookingWorks':
    'בחרו נכס, תאריכים ותמחור, ואז אשרו ושלמו במסך ההזמנה. העוזר לעולם לא משלם במקומכם.',
  'assistant.faq.voiceHelp':
    'אפשר לחפש („חדר כושר בתל אביב”), לפתוח סוג („חדר ישיבות”), לנווט („עבור למועדפים”), למחוק את כל המועדפים („תמחק לי את כל המועדפים”), לשאול שאלות, או לומר „הזמן את זה” אחרי פתיחת נכס — תמיד עם אישור שלכם. הקישו על אייקון הרמקול כדי לשמוע תשובות בקול.',
  'header.lastErrorInspect': 'הצגת השגיאה האחרונה',
  'header.lastErrorTitle': 'שגיאה אחרונה',
  'header.lastErrorEmpty': 'עדיין לא נרשמה שגיאה.',
  'header.lastErrorWhen': 'מתי',
  'header.lastErrorSource': 'מקור',
  'header.lastErrorCode': 'קוד שגיאה',
  'header.lastErrorDescription': 'תיאור',
  'header.lastErrorNetwork': 'רשת',
  'header.lastErrorContextJson': 'הקשר בקשה (JSON)',
  'header.lastErrorResponseJson': 'תגובת API (JSON)',
  'header.lastErrorClear': 'ניקוי שגיאה',
  'header.notificationsTest': 'התראות — בדיקת חיבור',
  'header.notificationsTitle': 'התראות',
  'header.notificationsSubtitle': 'הזמנות שמתחילות ב-24 השעות הקרובות',
  'header.notificationsLoading': 'טוען הזמנות…',
  'header.notificationsEmpty': 'אין התראות חדשות.',
  'header.notificationsSignIn': 'התחבר/י כדי לראות תזכורות להזמנות קרובות.',
  'header.notificationsViewAll': 'כל ההזמנות',
  'header.signIn': 'התחברות',
  'header.register': 'הרשמה',
  'header.greeting': 'שלום, {name}',
  'header.logOut': 'התנתקות',
  'header.guest': 'אורח',
  'desktopBanner.navLabel': 'קטגוריות',
  'desktopBanner.searchPlaceholder': 'מה תרצו להזמין היום?',
  'desktopBanner.uploadProperty': 'העלאת נכס',

  'home.allTypes': 'כל הסוגים',
  'home.mostPopular': 'נכסים פופולריים',
  'home.recommended': 'מומלצים באזור שלך',
  'home.officesNearby': 'בסביבה שלך',
  'home.gymsNearby': 'חדרי כושר בסביבה שלך',
  'home.noGymsNearby': 'אין עדיין חדרי כושר בסביבה להצגה.',
  'home.frequentlyBooked': 'נשכרים לעיתים קרובות',
  'home.recentlyViewed': 'נצפו לאחרונה',
  'home.noRecentlyViewed': 'נכסים שתפתח/י יופיעו כאן.',
  'home.promoAds': 'מודעות',
  'home.promoAdsPrev': 'מודעות קודמות',
  'home.promoAdsNext': 'מודעות הבאות',
  'home.promoAd.offizzLogo': 'Placy',
  'home.promoAd.billboard': 'פרסום חוצות',
  'home.promoAd.dynamicOffice': 'משרד גמיש עם Placy',
  'home.promoAd.registerDiscount': 'הירשמו עכשיו ותהנו מ-10% הנחה',
  'home.promoAd.referFriend': 'חבר מביא חבר — קרדיט 10% לכם והנחה 10% להם',
  'home.promoAd.appLocations': '3 מיקומים | יום אחד — והכל באפליקציה אחת',
  'home.promoAd.flexibleOffice': 'המשרד המתאים לרגע המתאים',
  'home.promoAd.appDiscover': 'גלו את כל מה שיש באפליקציית Placy',
  'home.showAll': 'הצג הכל',

  'favorites.title': 'מועדפים',
  'favorites.loading': 'טוען את המועדפים…',
  'favorites.empty': 'אין עדיין מקומות מועדפים. לחצו על הלב על מקום כדי לשמור אותו כאן.',
  'favorites.add': 'הוסף את {title} למועדפים',
  'favorites.remove': 'הסר את {title} מהמועדפים',
  'favorites.backToList': '→ חזרה למועדפים',
  'favorites.removeFromList': 'הסר את {title} מהמועדפים',
  'favorites.removeFromListShort': 'הסר',
  'home.loadingSpaces': 'טוען מקומות…',
  'home.loadSpacesError': 'לא ניתן לטעון מקומות. נסה שוב מאוחר יותר.',
  'home.noSpaces': 'אין מקומות להצגה עדיין.',
  'home.browseAsset': 'עיון ב־{title}',
  'home.carouselPrev': 'הקודם {section}',
  'home.carouselNext': 'הבא {section}',
  'home.browseByAssetType': 'עיון לפי סוג נכס',
  'home.searchCategoriesTitle': 'מה תרצה לחפש?',
  'home.bookingCategoriesTitle': 'מה מזמינים היום',
  'home.categoryFlipCta.privateOffice': 'לכל המשרדים הפרטיים',
  'home.categoryFlipCta.openSpace': 'לכל מתחמי ה-Open Space',
  'home.categoryFlipCta.conferenceRoom': 'לכל חדרי הישיבות',
  'home.categoryFlipCta.gym': 'לכל חדרי הכושר',
  'home.categoryFlipCta.parking': 'לכל החניות',
  'home.categoryFlipCta.podcastStudio': 'לכל חדרי הפודקסטים',
  'home.categoryFlipCta.lectureRoom': 'לכל אולמות ההרצאות',
  'home.categoryFlipCta.clinic': 'לכל תאי הטיפול',
  'home.categoryFlipCta.businessLounge': 'לכל הטרקלינים',
  'home.categoryFlipCta.classroom': 'לכל הכיתות',
  'home.categoryFlipCta.workshop': 'לכל חדרי הסדנאות',
  'home.searchCategoriesSeeMore': 'ראה עוד',
  'home.prevAssetTypes': 'סוגי נכסים קודמים',
  'home.nextAssetTypes': 'סוגי נכסים הבאים',
  'home.assetSubTitleNew': 'חדש בשוק',
  'home.assetSubTitlePrime': 'מיקום מרכזי',
  'home.partnerLogos': 'מותגים שותפים',
  'home.partnerLogosPrev': 'לוגואים קודמים',
  'home.partnerLogosNext': 'לוגואים הבאים',

  'assetType.parking': 'חניה',
  'assetType.meeting': 'חדר ישיבות',
  'assetType.openSpace': 'מרחב פתוח',
  'assetType.office': 'משרד',

  'social.featuredProfiles': 'פרופילים מומלצים',
  'social.prevProfiles': 'פרופילים קודמים',
  'social.nextProfiles': 'פרופילים הבאים',
  'social.yourProfile': 'אני',
  'social.addPost': 'הוסף סטורי',
  'social.postCount': '{count} סטוריז',
  'social.viewPosts': 'צפה ב־{count} סטוריז של {name}',
  'social.viewUserStories': 'צפה בסטוריז של {name}',

  'imagePicker.title': 'הוסף תמונה',
  'imagePicker.addToStory': 'הוספה לסטורי',
  'imagePicker.recents': 'אחרונים',
  'imagePicker.gallery': 'גלריה',
  'imagePicker.camera': 'מצלמה',
  'imagePicker.choosePhoto': 'בחר תמונה',
  'imagePicker.loading': 'טוען תמונות',
  'imagePicker.captionLabel': 'כיתוב (אופציונלי)',
  'imagePicker.captionPlaceholder': 'כתוב משהו…',
  'social.addProfileComingSoon': 'הוספת פרופיל (בקרוב)',
  'social.profileComingSoon': '{name} (בקרוב)',

  'social.composer.title': 'סטורי חדש',
  'social.composer.expiryHint': 'סטוריז נעלמים אחרי 48 שעות. ניתן לשמור עד 5 סטוריז פעילים.',
  'social.composer.message': 'כיתוב (אופציונלי)',
  'social.composer.messagePlaceholder': 'הוסף כיתוב קצר…',
  'social.composer.mediaType': 'מדיה',
  'social.composer.modeImageAudio': 'תמונה (+ אודיו אופציונלי)',
  'social.composer.modeVideo': 'וידאו',
  'social.composer.pickImage': 'בחר תמונה',
  'social.composer.changeImage': 'החלף תמונה',
  'social.composer.pickAudio': 'בחר אודיו',
  'social.composer.pickAudioOptional': 'הוסף אודיו (אופציונלי)',
  'social.composer.changeAudio': 'החלף אודיו',
  'social.composer.audioOptionalHint': 'אודיו הוא אופציונלי. קבצים ארוכים יותר ייחתכו ל־15 השניות הראשונות.',
  'social.composer.videoDurationHint': 'סרטונים עד {maxMb} MB. סרטונים ארוכים יותר ייחתכו ל־30 השניות הראשונות.',
  'social.composer.trimmedNotice': 'המדיה נחתכה לאורך המותר.',
  'social.composer.trimmedAudioNotice': 'האודיו נחתך ל־15 השניות הראשונות.',
  'social.composer.trimmedVideoNotice': 'הווידאו נחתך ל־30 השניות הראשונות.',
  'social.composer.preparingMedia': 'מכין מדיה…',
  'social.composer.pickVideo': 'בחר וידאו',
  'social.composer.changeVideo': 'החלף וידאו',
  'social.composer.publish': 'פרסם סטורי',
  'social.composer.publishing': 'מפרסם…',
  'social.composer.error.generic': 'לא ניתן לפרסם את הסטורי. נסה שוב.',
  'social.composer.error.social-missing-media': 'בחר תמונה כדי לפרסם.',
  'social.composer.error.social-image-type': 'בחר קובץ תמונה.',
  'social.composer.error.social-image-too-large': 'התמונה גדולה מדי.',
  'social.composer.error.social-audio-type': 'בחר קובץ אודיו.',
  'social.composer.error.social-audio-too-large': 'קובץ האודיו גדול מדי.',
  'social.composer.error.social-audio-duration': 'לא ניתן לקרוא את אורך קובץ האודיו.',
  'social.composer.error.social-audio-trim': 'לא ניתן לחתוך את האודיו. נסה קובץ קצר יותר.',
  'social.composer.error.social-video-type': 'בחר קובץ וידאו.',
  'social.composer.error.social-video-too-large': 'קובץ הווידאו גדול מדי (מקסימום {maxMb} MB).',
  'social.composer.error.social-video-duration': 'לא ניתן לקרוא את אורך קובץ הווידאו.',
  'social.composer.error.social-video-trim': 'לא ניתן לחתוך את הווידאו. נסה קובץ קצר יותר.',
  'social.composer.error.social-save-failed': 'לא ניתן לפרסם את הסטורי. נסה שוב בעוד רגע.',
  'social.composer.error.social-post-limit': 'ניתן לשמור עד 5 סטוריז פעילים. מחק סטורי ישן קודם.',
  'social.composer.error.social-server-error':
    'השרת לא הצליח לשמור את הסטורי (שגיאה 500). צוות הבקאנד צריך לבדוק את לוגי שירות הסטוריז.',
  'social.viewer.prev': 'הסטורי הקודם',
  'social.viewer.next': 'הסטורי הבא',
  'social.viewer.pause': 'השהה סטורי',
  'social.viewer.resume': 'המשך סטורי',
  'social.viewer.close': 'סגור סטוריז',
  'social.viewer.prevAccount': 'החשבון הקודם',
  'social.viewer.nextAccount': 'החשבון הבא',
  'social.viewer.mute': 'השתק',
  'social.viewer.unmute': 'בטל השתקה',
  'social.viewer.storyIndex': '{current} / {total}',
  'social.viewer.hoursAgo': 'לפני {hours} שע׳',
  'social.viewer.daysAgo': 'לפני {days} ימים',
  'social.viewer.remove': 'הסר סטורי',
  'social.viewer.removeConfirm': 'להסיר את הסטורי? הוא ייעלם מהרצועה שלך.',
  'social.viewer.removing': 'מסיר…',
  'social.viewer.removeFailed': 'לא ניתן להסיר את הסטורי. נסה שוב.',
  'social.viewer.message': 'הודעה',
  'social.viewer.messagePlaceholder': 'הודעה אל {name}…',
  'social.viewer.messageSend': 'שליחה',
  'social.viewer.messageSent': 'נשלח',
  'social.viewer.messageSendFailed': 'לא ניתן לשלוח את ההודעה. נסה שוב.',
  'social.viewer.openChat': 'פתח שיחה',

  'auth.account': 'חשבון',
  'auth.error.userDoesNotExist': 'המשתמש לא קיים.',
  'auth.signIn': 'התחברות',
  'auth.register': 'הרשמה',
  'auth.register.policyIntro':
    'בחרו את סוג החשבון למטה והשלימו את ההרשמה. לאחר הרשמה פעם אחת לסוג זה, אפשר להאיץ כניסות עתידיות עם Google.',
  'auth.register.googleHint': 'הרשמה או כניסה כ{type} עם Google.',
  'auth.register.appleHint': 'הרשמה או כניסה כ{type} עם Apple.',
  'auth.register.assetOwnerGoogleHint':
    'התחברו עם Google למילוי הפרטים. אם כבר יש לכם חשבון, תועברו להתחברות.',
  'auth.register.assetOwnerAppleHint':
    'התחברו עם Apple למילוי הפרטים. אם כבר יש לכם חשבון, תועברו להתחברות.',
  'auth.portal.title': 'כניסה',
  'auth.portal.phoneOtpTitle': 'טלפון',
  'auth.portal.phoneOtpHint': 'הזינו מספר לקבלת קוד חד-פעמי להתחברות',
  'auth.portal.phoneOtpLabel': 'מספר טלפון',
  'auth.portal.phoneOtpPlaceholder': '05XXXXXXXX',
  'auth.portal.phoneOtpComingSoon': 'כניסה עם טלפון — בקרוב.',
  'auth.portal.phoneOtpNotConfigured':
    'כניסה עם טלפון דורשת הגדרות Firebase. הוסיפו REACT_APP_FIREBASE_* ל-.env.development.local או עדכנו את src/firebaseWebConfig.json. הפעילו מחדש את npm start.',
  'auth.portal.invalidPhone': 'הזינו מספר נייד תקין (למשל 05XXXXXXXX).',
  'auth.portal.invalidSmsCode': 'הזינו את הקוד מה-SMS.',
  'auth.portal.phoneCodeSent': 'שלחנו קוד ל-{phone}. הזינו אותו למטה.',
  'auth.portal.changePhone': 'מספר טלפון אחר',
  'auth.portal.smsCodePlaceholder': 'הזינו את הקוד מה-SMS',
  'auth.portal.phoneOtpUserNotRegistered':
    'מספר הטלפון לא רשום והשרת לא יכול ליצור חשבון קל אוטומטית. הירשמו תחילה או השתמשו בכניסה עם דוא"ל.',
  'auth.portal.phoneOtpSmsRegionBlocked':
    'שליחת SMS לא מופעלת לישראל (+972) ב-Firebase. השתמשו בכניסה עם דוא"ל בינתיים, או בקשו מהצוות לאפשר ישראל תחת Authentication → Settings → SMS region policy (ולהפעיל Phone ב-Sign-in method).',
  'auth.portal.phoneOtpPhoneAuthDisabled':
    'כניסה עם טלפון מושבתת ב-Firebase. יש להפעיל Phone תחת Authentication → Sign-in method.',
  'auth.portal.phoneOtpInvalidAppCredential':
    'בדיקת האבטחה לטלפון נכשלה. בפיתוח מקומי פתחו את האפליקציה ב-https://127.0.0.1:3020 (npm start מפנה מ-localhost אוטומטית). הוסיפו 127.0.0.1 תחת Firebase → Authentication → Settings → Authorized domains, או השתמשו במספר טלפון בדיקה של Firebase.',
  'auth.portal.phoneOtpRecaptchaReset':
    'בדיקת האבטחה לטלפון נכשלה (reCAPTCHA). האפליקציה תאפס את הבדיקה אוטומטית — נסו שוב לשלוח קוד. אם זה נמשך, רעננו את הדף (Ctrl+F5).',
  'auth.portal.phoneOtpSendTimeout':
    'התחברות בטלפון נעצרה בזמן המתנה לבדיקת האבטחה. לעיתים זה קורה כש-reCAPTCHA מוצג מחוץ למסך, או כש-HTTPS לא מהימן בפיתוח מקומי. רעננו (Ctrl+F5), תקנו את תעודת הפיתוח, או השתמשו בדוא"ל.',
  'auth.portal.phoneOtpSmsError39':
    'Firebase חסם את שליחת ה-SMS (שגיאה 39). זו מגבלת הגנה של Firebase — לא באג באפליקציה. המגבלה יכולה לחול על המספר, על כתובת ה-IP של הרשת (רשת סלולרית או Wi‑Fi משותפים), או על כל הפרויקט, וההמתנה אינה תמיד שעה (לעיתים 24 שעות ויותר). נסו רשת אחרת, הוסיפו מספר בדיקה ב-Firebase Console → Authentication → Phone, או התחברו עם דוא"ל. ב-Firebase Console בדקו גם Authentication → Settings → SMS region policy (ישראל +972), Usage/quotas, ושהפרויקט ב-Blaze לשליחת SMS אמיתית.',
  'auth.portal.phoneOtpApiNotDeployed':
    'ממשק כניסה עם טלפון עדיין לא פעיל בשרת (login/clients/phone החזיר 404). בקשו מה-backend לפרוס את הנתיבים, או השתמשו בכניסה עם דוא"ל בינתיים.',
  'auth.portal.phoneOtpRegisterNotDeployed':
    'מספר הטלפון לא רשום ורישום קל עם טלפון לא זמין בשרת (register/PrivateClient/phone החזיר 404). הירשמו עם דוא"ל תחילה, או בקשו מה-backend לפרוס את נתיב הרישום.',
  'auth.portal.phoneOtpInvalidFirebaseToken':
    'השרת דחה את אסימון Firebase של הטלפון (פרויקט באסימון: {tokenProject}, האפליקציה מוגדרת ל: {appProject}). ודאו ש-REACT_APP_FIREBASE_* תואם לפרויקט Firebase שה-backend מאמת מולו.',
  'auth.portal.switchToEmail': 'השתמשו בדוא"ל במקום',
  'auth.portal.switchToPhone': 'השתמשו בטלפון במקום',
  'auth.portal.emailOtpTitle': 'דוא"ל',
  'auth.portal.emailHint': 'הזינו כתובת דוא"ל לקבלת קוד חד-פעמי להתחברות',
  'auth.portal.emailLabel': 'דוא"ל',
  'auth.portal.emailPlaceholder': 'you@example.com',
  'auth.portal.codeLabel': 'קוד חד-פעמי',
  'auth.portal.codePlaceholder': 'הזינו את הקוד מהדוא"ל',
  'auth.portal.sendCode': 'שליחת קוד',
  'auth.portal.verifyCode': 'כניסה',
  'auth.portal.codeSent': 'שלחנו קוד ל-{email}. הזינו אותו למטה.',
  'auth.portal.changeEmail': 'שימוש בדוא"ל אחר',
  'auth.portal.invalidEmail': 'הזינו כתובת דוא"ל תקינה.',
  'auth.portal.invalidCode': 'הזינו את הקוד שנשלח אליכם בדוא"ל.',
  'auth.portal.otpNotAvailable':
    'כניסה עם קוד בדוא"ל אינה זמינה בשרת זה עדיין. השתמשו ב-Google או באפשרויות כניסה אחרות למטה.',
  'auth.portal.otpUserNotRegistered':
    'כתובת דוא"ל זו עדיין לא רשומה והשרת לא הצליח ליצור חשבון בסיסי אוטומטית. בקשו מהצוות לאפשר יצירת חשבון ב-OTP (register/PrivateClient/otp/send), או הירשמו תחילה.',
  'auth.portal.otpWrongServerRole':
    'ההתחברות בדוא"ל הצליחה אך השרת הקצה role_id {roleId}, ולא את תפקיד {type} שדף זה מצפה לו. ייתכן שהדוא"ל מקושר לסוג חשבון אחר — השתמשו בדף ההתחברות המתאים או פנו לתמיכה.',
  'auth.portal.otpSendFailed': 'לא ניתן לשלוח קוד התחברות.',
  'auth.portal.otpVerifyFailed': 'לא ניתן לאמת את קוד ההתחברות.',
  'auth.portal.otpSignInRejected': 'ההתחברות נדחתה. בדקו את הפרטים או את גישת החשבון.',
  'auth.portal.otpLoginNotFound': 'כתובת ההתחברות לא נמצאה. בדקו את הגדרות ה-API.',
  'auth.portal.otpServerError': 'השרת לא השלים את ההתחברות. נסו שוב מאוחר יותר.',
  'auth.portal.otpRequestFailed': 'לא ניתן להשלים את ההתחברות. בדקו את הפרטים שהזנתם.',
  'auth.portal.otpSignInFailed': 'ההתחברות נכשלה.',
  'auth.portal.otpNetworkUnreachable': 'לא ניתן להגיע לשרת. בדקו את החיבור, ה-proxy או הגדרות CORS.',
  'auth.portal.otpNetworkError': 'משהו השתבש בעת פנייה לשרת.',
  'auth.portal.otpInvalidCode': 'קוד ההתחברות שגוי. נסו שוב.',
  'auth.portal.otpExpired': 'פג תוקף קוד ההתחברות. בקשו קוד חדש.',
  'auth.portal.otpTooManyAttempts': 'יותר מדי ניסיונות. המתינו ונסו שוב.',
  'auth.portal.phoneHint': 'הזינו מספר טלפון או דוא"ל לקבלת קוד אימות',
  'auth.portal.phoneLabel': 'מספר טלפון או דוא"ל',
  'auth.portal.phonePlaceholder': 'מספר טלפון או דוא"ל',
  'auth.portal.enter': 'כניסה',
  'auth.portal.or': 'או',
  'auth.portal.google': 'Sign in with Google',
  'auth.portal.googleEmailHint':
    'התחברו עם Google למעלה. בחרו בסוג התחברות שמתאים לחשבון Placy שלכם (לא תמיד לקוח פרטי).',
  'auth.portal.googleEmailHintPrivate': 'השתמשו בהתחברות Google למעלה לכתובת Gmail זו.',
  'auth.portal.googleLoginTypeMismatch':
    'חשבון Google זה אינו תואם לסוג ההתחברות שנבחר. בחרו למטה את סוג ההתחברות שבו נרשמתם ל-Placy ונסו שוב עם Google.',
  'auth.portal.googleUserNotRegistered':
    'חשבון Google זה עדיין לא רשום והשרת לא הצליח ליצור חשבון בסיסי אוטומטית. נסו התחברות עם קוד בדוא״ל למעלה, או בקשו מהצוות לאפשר יצירת חשבון בהתחברות Google.',
  'auth.portal.googleWrongServerRole':
    'התחברות Google הצליחה אך השרת הקצה role_id {roleId}, ולא את תפקיד {type} שעמוד זה מצפה לו (לקוחות פרטיים צריכים role_id 1). ייתכן שאימייל Google עדיין מקושר לסוג חשבון אחר בשרת — בקשו מהתמיכה לתקן או למחוק, או הירשמו עם הסוג הנכון.',
  'auth.portal.googleNotConfigured':
    'יש להגדיר REACT_APP_GOOGLE_OAUTH_CLIENT_ID (או clientId ב-src/devGoogleOAuthClientId.json) כדי לאפשר התחברות עם Google.',
  'auth.portal.googleLoadFailed': 'לא ניתן לטעון את Google Sign-In. בדקו את החיבור ונסו שוב.',
  'auth.portal.googlePlaySigning':
    'התחברות Google אינה מורשית להתקנת Play Store זו. ב-Google Cloud הוסיפו לקוח OAuth מסוג Android לחבילה ai.offizz.app עם SHA-1 של מפתח החתימה של Play (Play Console → Protected with Play → Play app signing).',
  'auth.portal.googleNativeNotReady':
    'התחברות Google במכשיר זה אינה מוכנה. סגרו את האפליקציה לגמרי ונסו שוב. אם זה נמשך, ייתכן שיידרש בניית Play חדשה.',
  'auth.portal.googleMissingIdToken':
    'התחברות Google לא החזירה אסימון מזהה. ודאו שמזהה לקוח ה-Web מוגדר כ-serverClientId לאפליקציית Android.',
  'auth.portal.googleSigningIn': 'מתחברים עם Google…',
  'auth.portal.googleNotEnabled':
    'התחברות עם Google אינה מופעלת בשרת. התחברו עם שם משתמש וסיסמה למטה, או בקשו מהצוות להוסיף נקודת קצה ל-Google.',
  'auth.portal.googleUnavailable':
    'התחברות עם Google אינה זמינה בשרת. השתמשו בשם משתמש וסיסמה למטה, או נסו שוב מאוחר יותר.',
  'auth.portal.apple': 'התחברות עם Apple',
  'auth.portal.appleLoginTypeMismatch':
    'חשבון Apple זה אינו תואם לסוג ההתחברות שנבחר. פתחו את סוג ההתחברות למטה ובחרו את התפקיד שבו נרשמתם, ונסו שוב עם Apple.',
  'auth.portal.appleUserNotRegistered':
    'חשבון Apple זה עדיין לא רשום והשרת לא הצליח ליצור חשבון lite אוטומטית. נסו התחברות עם קוד אימייל למעלה, או בקשו מהצוות להפעיל find-or-create בהתחברות Apple.',
  'auth.portal.appleWrongServerRole':
    'התחברות Apple הצליחה אך השרת הקצה role_id {roleId}, ולא את תפקיד {type} שהדף מצפה לו (לקוחות פרטיים צריכים role_id 1). ייתכן שהאימייל של Apple מקושר לסוג חשבון אחר — פנו לתמיכה או הירשמו עם הסוג הנכון.',
  'auth.portal.appleNotConfigured':
    'יש להגדיר Services ID ai.offizz.dev וכתובת חזרה התואמת ל-REACT_APP_APPLE_REDIRECT_URI (dev: https://dev.offizz.ai/auth/apple/callback, app: https://app.offizz.ai/auth/apple/callback).',
  'auth.portal.appleLoadFailed': 'לא ניתן להשלים את Apple Sign-In. בדקו את החיבור ונסו שוב.',
  'auth.portal.appleSigningIn': 'מתחברים עם Apple…',
  'auth.portal.appleNotEnabled':
    'התחברות עם Apple אינה מופעלת בשרת. התחברו עם שם משתמש וסיסמה למטה, או בקשו מהצוות להוסיף נקודת קצה ל-Apple.',
  'auth.portal.appleUnavailable':
    'התחברות עם Apple אינה זמינה בשרת. השתמשו בשם משתמש וסיסמה למטה, או נסו שוב מאוחר יותר.',
  'auth.portal.appleMissingToken':
    'התחברות Apple לא שלחה identity token. נסו שוב, או השתמשו בשיטת התחברות אחרת.',
  'auth.portal.appleInvalidToken':
    'אסימון Apple נדחה (לא תקין, פג תוקף, או audience שגוי). ודאו ש-Services ID הוא ai.offizz.dev — לא App ID ai.offizz.app.',
  'auth.portal.lastUsedApple': 'שימוש אחרון',
  'auth.portal.lastUsedGoogle': 'שימוש אחרון',
  'auth.portal.lastUsedPassword': 'שימוש אחרון',
  'auth.portal.lastUsedOtp': 'שימוש אחרון',
  'auth.portal.usePasswordInstead': 'התחברות עם סיסמה במקום',
  'auth.portal.otpModeTab': 'קוד חד־פעמי',
  'auth.portal.passwordModeTab': 'סיסמה',
  'auth.portal.backToOtp': 'חזרה לקוד חד־פעמי',
  'auth.portal.passwordHint': 'הזינו אימייל וסיסמה להתחברות',

  'auth.forgotPassword.link': 'שכחת סיסמה?',

  'auth.forgotPassword.title': 'איפוס סיסמה',
  'auth.forgotPassword.intro':
    'הזינו את האימייל או מספר הטלפון של החשבון. נשלח קוד חד־פעמי כדי שתוכלו לקבוע סיסמה חדשה.',
  'auth.forgotPassword.emailHint': 'הזינו אימייל כדי לקבל קוד לאיפוס סיסמה',
  'auth.forgotPassword.phoneHint': 'הזינו מספר טלפון כדי לקבל קוד לאיפוס סיסמה',
  'auth.forgotPassword.codeSentEmail': 'שלחנו קוד אל {email}. הזינו אותו למטה.',
  'auth.forgotPassword.codeSentPhone': 'שלחנו קוד אל {phone}. הזינו אותו למטה.',
  'auth.forgotPassword.verifyCode': 'אימות קוד',
  'auth.forgotPassword.setPasswordHint': 'בחרו סיסמה חדשה לחשבון זה.',
  'auth.forgotPassword.newPassword': 'סיסמה חדשה',
  'auth.forgotPassword.confirmPassword': 'אימות סיסמה חדשה',
  'auth.forgotPassword.submitNewPassword': 'עדכון סיסמה',
  'auth.forgotPassword.success': 'הסיסמה עודכנה. התחברו עם הסיסמה החדשה.',
  'auth.forgotPassword.backToSignIn': 'חזרה להתחברות',
  'auth.forgotPassword.mismatch': 'הסיסמה החדשה ואימות הסיסמה חייבים להתאים.',
  'auth.forgotPassword.passwordRequired': 'יש להזין סיסמה חדשה.',
  'auth.forgotPassword.userNotFound':
    'לא נמצא חשבון לאימייל זה. בדקו את הכתובת, או הירשמו קודם.',
  'auth.forgotPassword.phoneUserNotFound':
    'לא נמצא חשבון למספר טלפון זה. בדקו את המספר, או הירשמו קודם.',
  'auth.forgotPassword.sendFailed': 'לא ניתן לשלוח קוד לאיפוס סיסמה.',
  'auth.forgotPassword.verifyFailed': 'לא ניתן לאמת את קוד האיפוס.',
  'auth.forgotPassword.completeFailed': 'לא ניתן לעדכן את הסיסמה. נסו שוב.',
  'auth.forgotPassword.noResetToken':
    'הקוד אומת אך השרת לא החזיר אסימון איפוס. נסו שוב, או פנו לתמיכה.',
  'auth.forgotPassword.noPasswordAccount':
    'חשבון זה אינו משתמש בסיסמה. התחברו עם Google, Apple או עם קוד חד־פעמי.',
  'auth.forgotPassword.tokenExpired': 'קוד האיפוס פג. בקשו קוד חדש.',
  'auth.portal.credentialsTitle': 'התחברות עם שם משתמש וסיסמה',
  'auth.portal.username': 'שם משתמש',
  'auth.portal.comingSoon': 'בקרוב',
  'auth.portal.noAccount': 'אין לך חשבון?',
  'auth.portal.registerLink': 'הירשם',
  'auth.portal.mainGoogleHint': 'התחברות או הרשמה עם Google.',
  'auth.portal.roleGoogleHint': 'השתמשו ב-Google עבור {type} אם כבר נרשמתם לסוג חשבון זה עם Google.',
  'auth.portal.otherSignInOptions': 'אפשרויות כניסה נוספות',
  'auth.portal.assetOwnerLink': 'בעל נכס',
  'auth.assetOwner.signInTitle': 'כניסת בעל נכס',
  'auth.assetOwner.signInIntro': 'התחברו כדי לנהל את הנכסים, ההזמנות ופרופיל העסק שלכם.',
  'auth.assetOwner.registerTitle': 'רישום בעל נכס',
  'auth.assetOwner.registerLink': 'הירשמו כבעל נכס',
  'auth.portal.otherSignInTitle': 'אפשרויות כניסה והרשמה נוספות',
  'auth.portal.otherSignInIntro':
    'התחברות עם שם משתמש וסיסמה, או בחירת סוג החשבון שלכם.',
  'auth.portal.contactPageTitle': 'צור קשר',
  'auth.portal.contactPageIntro': 'פנו אלינו במייל ונעזור לכם להתחבר.',
  'auth.portal.contactEmailLabel': 'דוא"ל',
  'auth.portal.contactWhatsAppLabel': 'WhatsApp',
  'auth.portal.contactPrompt': 'נתקלת בבעיה?',
  'auth.portal.contactAction': 'צור קשר',
  'auth.portal.clearAppData': 'ניקוי נתונים שמורים',
  'auth.portal.clearAppDataBusy': 'מנקה…',
  'auth.portal.clearAppDataConfirm':
    'למחוק את כל הנתונים השמורים של האפליקציה במכשיר? תבוצע התנתקות. שמות שמורים ורשימות cache יימחקו והעמוד ייטען מחדש. המועדפים, פרטי ההזמנה, טיוטות נכסים, רמזי פרופיל ובחירת השפה יישמרו במכשיר.',

  'login.login': 'התחברות',
  'login.loginType': 'סוג התחברות',
  'login.identifier': 'מזהה',
  'login.password': 'סיסמה',
  'login.credentialsRequired': 'יש להזין מזהה וסיסמה.',
  'login.clear': 'נקה',
  'login.blockedSignedIn': 'כבר מחובר/ת.',
  'login.blockedSignInElse': 'כבר מחובר/ת. התנתק/י כדי להתחבר כמשתמש/ת אחר/ת.',
  'login.signInNoToken': 'ההתחברות הצליחה אך התגובה לא הייתה JSON תקין עם accessToken.',
  'login.signInEmptyBody': 'ההתחברות הצליחה (HTTP {status}) אך גוף התגובה ריק — נדרש accessToken.',
  'login.option.businessClient': 'לקוח עסקי',
  'login.option.privateClient': 'לקוח פרטי',
  'login.option.businessWorker': 'עובד עסקי',
  'login.option.assetOwner': 'בעל נכס',
  'login.option.businessAssetOwner': 'בעל נכס',
  'login.option.privateAssetOwner': 'בעל נכס',

  'auth.passwordRequirementsInParentheses':
    '(מינימום 8 תווים; אות גדולה אחת A–Z; אות קטנה אחת a–z; ספרה אחת 0–9; תו מיוחד אחד למשל @ # $ % !)',

  'register.register': 'הרשמה',
  'register.registerType': 'סוג הרשמה',
  'register.contactFirstName': 'שם פרטי של איש קשר',
  'register.contactLastName': 'שם משפחה של איש קשר',
  'register.assetOwnerPayout.title': 'חשבון בנק לתשלומים',
  'register.assetOwnerPayout.payoutCountry': 'מדינת תשלום',
  'register.assetOwnerPayout.countryIl': 'ישראל',
  'register.assetOwnerPayout.countryUs': 'ארצות הברית',
  'register.assetOwnerPayout.accountHolderName': 'שם בעל החשבון',
  'register.assetOwnerPayout.bankNumber': 'מספר בנק',
  'register.assetOwnerPayout.branchNumber': 'מספר סניף',
  'register.assetOwnerPayout.accountNumber': 'מספר חשבון',
  'register.assetOwnerPayout.routingNumber': 'מספר ניתוב (ABA)',
  'register.assetOwnerPayout.accountType': 'סוג חשבון',
  'register.assetOwnerPayout.accountTypeChecking': 'עו"ש',
  'register.assetOwnerPayout.accountTypeSavings': 'חיסכון',
  'register.assetOwnerPayout.transferDay': 'יום העברת תשלום',
  'register.assetOwnerPayout.transferDayOption.2': 'ה-2 בכל חודש',
  'register.assetOwnerPayout.transferDayOption.10': 'ה-10 בכל חודש',
  'register.assetOwnerPayout.transferDayOption.15': 'ה-15 בכל חודש',
  'register.assetOwnerPayout.selectTransferDay': 'בחרו יום העברה…',
  'register.assetOwnerPayout.selectAccountType': 'בחרו סוג חשבון…',
  'register.assetOwnerPayout.hintIl':
    'תשלומים בישראל: מספר בנק (2 ספרות), סניף (3 ספרות) ומספר חשבון.',
  'register.assetOwnerPayout.hintUs':
    'תשלומי ACH בארה"ב: מספר ניתוב בן 9 ספרות וחשבון עו"ש או חיסכון.',
  'register.assetOwnerPayout.error.accountHolderRequired': 'הזינו את שם בעל החשבון.',
  'register.assetOwnerPayout.error.accountNumberRequired': 'הזינו מספר חשבון.',
  'register.assetOwnerPayout.error.accountNumberReenter':
    'הזינו מחדש את מספר החשבון המלא כדי לשמור שינויים בתשלום (המספר השמור מוצג באופן חלקי מטעמי אבטחה).',
  'register.assetOwnerPayout.error.bankNumberIl': 'מספר בנק חייב להיות 2 ספרות (למשל 12 להפועלים).',
  'register.assetOwnerPayout.error.branchNumberIl': 'מספר סניף חייב להיות 3 ספרות.',
  'register.assetOwnerPayout.error.accountNumberIl': 'הזינו מספר חשבון ישראלי תקין (ספרות בלבד).',
  'register.assetOwnerPayout.error.routingNumberUs': 'מספר ניתוב חייב להיות 9 ספרות.',
  'register.assetOwnerPayout.error.accountNumberUs': 'מספר חשבון בארה"ב: 4–17 ספרות.',
  'register.assetOwnerPayout.error.accountTypeUs': 'בחרו עו"ש או חיסכון.',
  'register.assetOwnerPayout.error.transferDayRequired': 'בחרו יום להעברת תשלום.',
  'register.businessLogo': 'לוגו עסק',
  'register.businessLogoAdd': 'הוספת לוגו עסק',
  'register.businessLogoChange': 'החלפת לוגו',
  'register.businessLogoRemove': 'הסרה',
  'register.businessLogoAfterSignIn':
    'אופציונלי. הלוגו יישמר בפרופיל לאחר ההתחברות (לא נשלח בשלב הרישום).',
  'register.businessLogoTooLarge': 'גודל קובץ הלוגו חייב להיות עד 12 מ״ב.',
  'register.businessLogoTooLargePayload':
    'הלוגו גדול מדי לרישום (גודל הבקשה המלא חייב להישאר מתחת לכ־100 ק״ב). נסו תמונה קטנה או פשוטה יותר.',
  'register.success': 'המשתמש נרשם בהצלחה.',
  'register.successWithEmail': 'ההרשמה הושלמה. כתובת האימייל של החשבון: {email}.',
  'register.successOtherSignInHint':
    'להתחברות, בחרו {type} במסך הבא והשתמשו בכתובת אימייל זו עם הסיסמה (לא במסך הקוד הראשי).',
  'register.successBusinessClientWorkerCode':
    'שתפו את קוד 8 הספרות הזה עם העובדים כדי שיוכלו להירשם כעובדי עסק: {code}',
  'register.successBusinessClientWorkerCodeHint':
    'עובדים בוחרים «עובד עסקי» בעמוד הרישום ומזינים את הקוד בשדה מזהה המעסיק.',
  'register.successBusinessClientWorkerCodePending':
    'חשבון העסק נוצר. התחברו כלקוח עסקי ופתחו פרופיל → פרטים כדי לראות את קוד רישום העובדים בן 8 הספרות.',
  'register.copyWorkerCode': 'העתקת קוד',
  'register.copyWorkerCodeDone': 'הועתק',
  'register.businessClientWorkerCode': 'קוד מעסיק (8 ספרות)',
  'register.businessWorkerCodeHint':
    'הזינו את קוד 8 הספרות שקיבל המעסיק בעת יצירת חשבון העסק.',
  'register.goToSignIn': 'מעבר להתחברות',
  'register.error.userAlreadyExists':
    'משתמש עם כתובת דוא"ל, מספר טלפון או מזהה עסק (ח.פ.) זה כבר קיים בשרת (כולל חשבונות מושבתים לאחר מחיקת חשבון).',
  'register.error.userAlreadyExistsSubmitted':
    'הערכים שנשלחו בבקשה זו: דוא"ל "{email}", טלפון "{phone}", מזהה עסק "{businessId}". השרת דוחה את הרישום אם אחד מהם כבר תפוס — לא רק כשכל השלושה תואמים לחשבון קודם.',
  'register.error.userAlreadyExistsGoogleEmail':
    'נרשמתם עם Google, ולכן כתובת הדוא"ל מגיעה מחשבון Google ולא ניתן לשנותה בטופס זה. השתמשו בחשבון Google אחר, או התחברו עם דוא"ל זה במקום להירשם שוב.',
  'register.error.userAlreadyExistsTryLogin':
    'נסו להתחבר כלקוח עסקי עם דוא"ל וסיסמה אלה. לחשבון חדש לגמרי, השתמשו בדוא"ל, טלפון ומזהה עסק שלא נרשמו מעולם ב-Placy, או פנו לתמיכה לשחרור המזהים הישנים.',
  'register.error.userAlreadyExistsPrivateClient':
    'משתמש עם כתובת דוא"ל או מספר טלפון זה כבר קיים בשרת (כולל חשבונות מושבתים לאחר מחיקת חשבון).',
  'register.error.userAlreadyExistsSubmittedPrivateClient':
    'הערכים שנשלחו בבקשה זו: דוא"ל "{email}", טלפון "{phone}". ברישום לקוח פרטי לא נשלח מזהה עסק (ח.פ.). השרת דוחה את הרישום אם הדוא"ל או הטלפון כבר תפוסים.',
  'register.error.userAlreadyExistsTryLoginPrivateClient':
    'נסו להתחבר כלקוח פרטי עם דוא"ל וסיסמה אלה. לחשבון חדש לגמרי, השתמשו בדוא"ל ובטלפון שלא נרשמו מעולם ב-Placy, או פנו לתמיכה לשחרור המזהים הישנים.',
  'register.error.badRequest':
    'נתוני הרישום אינם תקינים. בדקו שדות חובה, פורמט דוא"ל, מספר טלפון ופרטי חשבון בנק.',
  'register.error.badRequestWithStatus':
    'הרישום נדחה (שגיאה {status}). בדקו שדות חובה, דוא"ל, טלפון, מזהה עסק, מדינה ופרטי בנק.',
  'register.error.conflict': 'חשבון זה כבר קיים או מתנגש עם משתמש אחר.',
  'register.error.conflictWithStatus':
    'הרישום נכשל בגלל התנגשות (שגיאה {status}). ייתכן שהדוא"ל או הטלפון שייכים לחשבון קיים או מושבת. נסו להתחבר או השתמשו בפרטי קשר אחרים.',
  'register.error.forbidden': 'אין הרשאה לרשום עם פרטי ההתחברות האלה.',
  'register.error.rejected':
    'הרישום לא התקבל. ייתכן שכתובת הדוא"ל או הטלפון כבר רשומים — נסו להתחבר במקום. אם אתם צריכים סוג חשבון אחר, בחרו את סוג הרישום המתאים למעלה או השתמשו בכתובת דוא"ל אחרת.',
  'register.error.businessWorkerPublicRejected':
    'רישום עובד עסקי לא התקבל. בדקו את קוד המעסיק בן 8 הספרות מחשבון העסק. אם הדוא"ל או הטלפון כבר רשומים — התחברו במקום.',
  'register.error.businessWorkerSessionRejected':
    'פג תוקף ההתחברות כלקוח עסקי. התחברו שוב כלקוח עסקי ואז הוסיפו את העובד מהפרופיל.',
  'register.error.businessWorkerSessionRequired':
    'התחברו שוב כלקוח עסקי כדי לרשום עובד מהפרופיל, או התנתקו והשתמשו בדף הרישום הציבורי עם קוד המעסיק בן 8 הספרות.',
  'register.error.staleSession':
    'מושפעים עדיין מפגישת התחברות קודמת. התנתקו שוב, רעננו את הדף (רענון מלא), או נסו בחלון פרטי — ואם סוג החשבון שונה, השתמשו בכתובת דוא"ל חדשה.',
  'register.error.forbiddenWithStatus': 'הרישום לא אושר (שגיאה {status}).',
  'register.error.serverWithStatus':
    'השרת לא הצליח להשלים את הרישום (שגיאה {status}). נסו שוב מאוחר יותר.',
  'register.error.serverInternalHint':
    'השרת לא השלים את הרישום (שגיאה {status}). אם מחקתם חשבון עם אותו דוא"ל או טלפון, ייתכן שהפרטים עדיין שמורים — נסו להתחבר, השתמשו בפרטי קשר אחרים, או פנו לתמיכה. אחרת שלחו את פרטי הבקשה לצוות השרת.',
  'register.error.requestFailedWithStatus': 'הרישום נכשל (שגיאה {status}).',
  'register.error.fieldRequired': 'יש למלא את {field}.',
  'register.error.fieldInvalidEmail': 'הזינו כתובת דוא"ל תקינה עבור {field}.',
  'register.error.fieldInvalidPhone': 'הזינו מספר טלפון תקין עבור {field}.',
  'register.error.fieldInvalidString': '{field} חייב להיות טקסט.',
  'register.error.fieldInvalidNumber': '{field} חייב להיות מספר.',
  'register.error.fieldConstraint': '{field}: {detail}',
  'register.error.requestFailed': 'הרישום נכשל. נסו שוב.',

  'userType.businessClient': 'לקוח עסקי',
  'userType.privateClient': 'לקוח פרטי',
  'userType.businessWorker': 'עובד עסקי',
  'userType.assetOwner': 'בעל נכס',
  'userType.businessAssetOwner': 'בעל נכס',
  'userType.privateAssetOwner': 'בעל נכס',

  'assets.title': 'נכסים',
  'assets.myAssetsTitle': 'הנכסים שלי',
  'assets.ownerEmpty': 'עדיין לא יצרת נכסים. עבור/י ליצירה כדי להוסיף נכס.',
  'assets.ownerMode': 'בעל נכס',
  'assets.apiLabel': 'ממשק נכסים',
  'assets.operation.getById': 'נכס (הצגה / עריכה / מחיקה)',
  'assets.operation.listMine': 'הנכסים שלי',
  'assets.operation.active': 'נכסים פעילים',
  'assets.operation.create': 'יצירת נכס',
  'assets.filter.country': 'מדינה',
  'assets.filter.region': 'אזור',
  'assets.filter.assetType': 'סוג נכס',
  'assets.filter.nameContains': 'שם מכיל',
  'assets.filter.nameOrAddressContains': 'שם, כתובת או תיאור מכילים',
  'assets.filter.allCountries': 'כל המדינות',
  'assets.filter.allRegions': 'כל האזורים',
  'assets.filter.allTypes': 'כל הסוגים',
  'assets.filter.selectCountryFirst': 'בחר מדינה תחילה',
  'assets.filter.loadingRegions': 'טוען אזורים…',
  'assets.filter.noRegions': 'אין אזורים למדינה זו',
  'assets.filter.listFilters': 'מסנני רשימה',
  'assets.filter.listFiltersTitle': 'מסנני רשימה',
  'assets.filter.placeholderSubstring': 'לפחות 3 אותיות…',
  'assets.filter.placeholderUuid': 'UUID',
  'assets.filter.placeholderAssetId': 'UUID או מזהה בן 8 ספרות',
  'assets.filter.noMatch': 'אין נכסים התואמים למסננים שלך.',
  'assets.filter.noOpen24h': 'אין נכסים עם גישה 24/7 ב{city}.',
  'assets.filter.noOpen24hGeneric': 'אין נכסים עם גישה 24/7.',
  'assets.filter.searchAllOffices': 'חפש את כל המשרדים ב{city}',
  'assets.filter.searchAllOfficesGeneric': 'חפש את כל המשרדים',
  'assets.search.loading': 'טוען נכסים…',
  'assets.search.loadingMore': 'טוען עוד…',
  'assets.search.loadingMoreListings': 'עוד נכסים בטעינה…',
  'assets.search.loadMore': 'טען עוד',
  'assets.search.endOfList': 'הגעתם לסוף הרשימה.',
  'assets.search.resultCount': 'מוצגים {count} מתוך {total}',
  'assets.search.resultCountPartial': 'מוצגים {count} לעת עתה',
  'assets.filter.clearFilters': 'נקה מסננים',
  'assets.filter.sort': 'מיון לפי',
  'assets.filter.sortName': 'שם (א–ת)',
  'assets.filter.sortPriceAsc': 'מחיר: מהזול ליקר',
  'assets.filter.sortPriceDesc': 'מחיר: מהיקר לזול',
  'assets.filter.sortDistance': 'מרחק',
  'form.picklist.loadingCountries': 'טוען מדינות…',
  'form.picklist.selectCountry': 'בחר מדינה…',
  'form.picklist.unavailable': 'לא זמין',
  'form.picklist.loadingRegions': 'טוען אזורים…',
  'form.picklist.selectRegion': 'בחר אזור…',
  'form.picklist.regionsUnavailable': 'אזורים לא זמינים',
  'form.picklist.noRegionsApi': 'לא הוחזרו אזורים',
  'form.picklist.pickRegionStale': 'בחר אזור (הרשימה עלולה להיות לא מעודכנת)',
  'form.picklist.loadingAssetTypes': 'טוען סוגי נכס…',
  'form.picklist.selectAssetType': 'בחר סוג נכס…',
  'form.picklist.searchCity': 'חפש עיר או יישוב…',
  'form.picklist.citySettlementHint': '{count} יישובים רשמיים בישראל — הקלד/י לסינון.',
  'form.picklist.selectCityFirst': 'בחר/י יישוב תחילה…',
  'form.picklist.searchStreet': 'חפש/י רחוב…',
  'form.picklist.streetManualPlaceholder': 'הקלד/י שם רחוב…',
  'form.picklist.streetManualOverride': 'הקלדה ידנית (רחוב שאינו ברשימה)',
  'form.picklist.streetNeedsCity': 'בחר/י יישוב כדי לטעון את רשימת הרחובות הרשמית.',
  'form.picklist.streetHint': '{count} רחובות רשמיים ביישוב זה — הקלד/י לסינון.',
  'form.picklist.streetNoOfficialList': 'אין רשימת רחובות רשמית ליישוב זה — השתמש/י בהקלדה ידנית.',
  'form.picklist.zipAutoPlaceholder': 'מתמלא אוטומטית',
  'form.picklist.zipAutoHint': 'מיקוד נקבע לפי היישוב והרחוב שבחרת.',
  'form.picklist.buildingPlaceholder': 'מספר בית / בניין',
  'assets.book.available': 'זמין להזמנה',
  'assets.book.view': 'צפה בנכס',
  'assets.signInToUse': 'התחבר/י כבעל נכס, לקוח או עובד עסקי כדי להשתמש בנכסים.',
  'assets.availableRoles': 'נכסים זמינים לבעלי נכסים, לקוחות ועובדים עסקיים.',
  'assets.createNotForClients': 'יצירת נכסים אינה זמינה לחשבונות לקוח עסקי או פרטי.',
  'assets.afterDisplayActions': 'פעולות לאחר הצגה',
  'assets.chooseImagesUpload': 'בחר קבצי תמונה (עד חמש)',
  'assets.assetImages': 'תמונות נכס',
  'assets.chooseImagesUpdate': 'בחר קבצי תמונה לעדכון',
  'assets.addUpToTenImages': 'הוסף עד 10 תמונות',
  'assets.mainImage': 'תמונה ראשית',
  'assets.mainImageListHint': 'מוצגת ברשימות נכסים',
  'assets.additionalImages': 'תמונות נוספות',
  'assets.browseMainImage': 'בחר תמונה ראשית…',
  'assets.browseAdditionalImages': 'הוסף תמונות…',
  'assets.removeImage': 'הסר',
  'assets.noMainImageYet': 'לא נבחרה תמונה ראשית.',
  'assets.noAdditionalImagesYet': 'אין תמונות נוספות.',
  'assets.additionalImageLabel': 'תמונה {n}',
  'assets.imagesSelected': '{n} / {max} נבחרו',
  'assets.imagesRePickRequired':
    'קבצי התמונה אינם מצורפים עוד. בחר/י שוב את התמונות לפני יצירת הנכס.',
  'assets.imagesAtLeastOne': 'יש להוסיף לפחות תמונה אחת לפני יצירת הנכס.',
  'assets.imagesTooMany': 'ניתן לצרף עד {max} קובצי תמונה.',
  'assets.imagesFileTooLarge':
    'התמונה „{name}” היא בגודל {sizeMb} MB; כל קובץ יכול להיות עד {maxMb} MB.',
  'assets.createPayloadFailed': 'לא ניתן להכין את בקשת היצירה.',
  'assets.idRequired': 'נדרש מזהה נכס.',
  'assets.shortIdNotInCatalog':
    'לא נמצא נכס פעיל עבור המזהה {id}. ייתכן שהוא הוסר מהמכירה או שהמזהה שגוי.',
  'assets.updateNotForAccount': 'עדכון נכסים אינו זמין לסוג החשבון שלך.',
  'assets.noChangesToSave': 'אין שינויים לשמירה.',
  'assets.availabilityNotPersisted':
    'השרת קיבל את השמירה אך לא שינה את זמינות ההזמנות ({tried}). יש לבקש מצוות ה-backend לאפשר asset_status ב-PATCH /assets/:id.',
  'assets.geo.title': 'מיקום במפה',
  'assets.geo.coordsSet': 'קואורדינטות: {lat}, {lng}',
  'assets.geo.coordsUnset':
    'טרם הוגדרו קואורדינטות. השתמשו ב«חיפוש לפי כתובת» או «פתיחה ב-Google Maps» כדי לקבוע אותן לפי הכתובת, ואז כווננו במידת הצורך.',
  'assets.geo.pickOnMap': 'הגדרת קואורדינטות',
  'assets.geo.openGoogleMaps': 'פתיחה ב-Google Maps',
  'assets.geo.fromAddress': 'חיפוש לפי כתובת',
  'assets.geo.lookingUp': 'מחפש…',
  'assets.geo.needAddress': 'הזינ/י לפחות עיר ורחוב בכתובת.',
  'assets.geo.geocodeFailed': 'לא ניתן לקבוע קואורדינטות. בדק/י את הכתובת ונסה/י שוב.',
  'assets.geo.invalidCoords': 'הזינ/י קו רוחב (-90…90) וקו אורך (-180…180) תקינים.',
  'assets.geo.dialogTitle': 'קואורדינטות הנכס',
  'assets.geo.dialogHint':
    'חפשו קואורדינטות לפי הכתובת או פתחו את Google Maps — המערכת תקבע אותן מהכתובת. ניתן לכוונן קו רוחב ואורך כאן ואז להחיל.',
  'assets.geo.latitude': 'קו רוחב',
  'assets.geo.longitude': 'קו אורך',
  'assets.geo.apply': 'החלה',
  'assets.loadingFacilities': 'טוען מתקנים…',
  'assets.noFacilitiesInApi': 'לא הוחזרו מתקנים מהשרת.',
  'assets.retry': 'נסה שוב',
  'assets.addUrl': 'הוסף כתובת',
  'assets.noImagesInThisListYet':
    'אין תמונות ברשימה הזו עדיין. הוסיפו קבצים או כתובות למטה, או השאירו ריק כדי לא לשנות.',
  'assets.imageUrlPlaceholder': 'https://… או /path/to/image.jpg',
  'assets.imageUrlAria': 'כתובת URL או נתיב תמונה להוספה',
  'assets.facilitiesAria': 'מתקנים לנכס זה',
  'assets.transportationAccessibility': 'תחבורה ונגישות',
  'assets.transportationAria': 'אפשרויות תחבורה ונגישות לנכס זה',
  'assets.noTransportationFacilities': 'אפשרויות תחבורה ונגישות עדיין לא זמינות מהשרת.',
  'assets.createTerms': 'תנאים',
  'assets.createTermsPlaceholder':
    'טקסט תנאים זמני לפרסום נכס. יש להחליף בנוסח הסופי של תנאי בעלות, מדיניות ביטול וכללי שימוש לפני העלאה לאוויר.',
  'assets.createTermsAgree': 'אני מסכים/ה לתנאים',
  'assets.createTermsRequired': 'יש לאשר את התנאים לפני יצירת נכס.',
  'assets.createContactConflict':
    'לא ניתן ליצור את הנכס כי השרת רואה שדוא״ל או טלפון איש הקשר כבר משויכים למשתמש אחר. רעננו את הדף ונסו שוב. אם הבעיה נמשכת, פנו לתמיכה.',
  'assets.pricingPriceRequired': 'יש להזין מחיר של אפס ומעלה לכל סוג תמחור שנבחר.',
  'assets.pricingAria': 'שיטות תמחור לנכס זה',
  'assets.addonsAria': 'תוספות לנכס זה',
  'assets.bookSignIn': 'התחבר/י כדי להזמין נכס זה.',
  'assets.failedFacilities': 'טעינת מתקנים נכשלה.',
  'assets.failedAddons': 'טעינת תוספות נכשלה.',
  'assets.failedPricing': 'טעינת סוגי תמחור נכשלה.',
  'assets.pricingTypesLegend': 'סוגי תמחור',
  'assets.pricingSuggestEstimate':
    'הצעה ל־{type} ב־{city}: {hourly}/שעה · {daily}/יום · {monthly}/חודש (לפי מיקום וסוג נכס).',
  'assets.pricingSuggestMarket':
    'הצעה ל־{type} ב־{city}: {hourly}/שעה · {daily}/יום · {monthly}/חודש (חציון מ־{n} נכסים דומים).',
  'assets.pricingSuggestApply': 'החל הצעות',
  'assets.pricingSuggestAnyType': 'סוג זה',
  'assets.pricingSuggestAnyCity': 'אזור זה',
  'assets.loadingPricingTypes': 'טוען סוגי תמחור…',
  'assets.noPricingTypes': 'אין סוגי תמחור בתשובת ה-API.',
  'assets.failedCountries': 'טעינת מדינות נכשלה',
  'assets.failedAssetTypes': 'טעינת סוגי נכסים נכשלה',
  'assets.failedDistricts': 'טעינת מחוזות נכשלה',
  'assets.failedRegions': 'טעינת אזורים נכשלה',
  'assets.updateOwnerOnly': 'עדכון זמין רק לנכסים בבעלותך.',
  'assets.noAssetId': 'לשורה זו אין מזהה נכס — לא ניתן לעדכן.',
  'assets.cannotReadResponse': 'לא ניתן לקרוא את תגובת הנכס כאובייקט.',
  'assets.deleteIdRequired': 'נדרש מזהה נכס למחיקה.',
  'assets.createSuccess': 'הנכס נוצר בהצלחה. מזהה נכס: {id}',
  'assets.updateSuccess': 'הנכס עודכן בהצלחה. מזהה נכס: {id}',
  'assets.editDisplayed': 'עריכת נכס',
  'assets.deleteDisplayed': 'מחיקת נכס',
  'assets.backToList': '→ חזרה לרשימה',
  'assets.backToSearch': '→ חזרה לחיפוש',
  'assets.updateAsset': 'עדכן נכס',
  'assets.cancelEdit': 'ביטול עריכה',
  'assets.bookingAvailabilityLegend': 'נראות להזמנות',
  'assets.availableForBooking': 'זמין להזמנות',
  'assets.statusUnavailableBadge': 'לא זמין',
  'assets.ownerSchedule.title': 'יומן הזמנות',
  'assets.ownerSchedule.viewMode': 'תצוגת יומן',
  'assets.ownerSchedule.viewDay': 'יום',
  'assets.ownerSchedule.viewWeek': 'שבוע',
  'assets.ownerSchedule.viewMonth': 'חודש',
  'assets.ownerSchedule.prev': 'תקופה קודמת',
  'assets.ownerSchedule.next': 'תקופה הבאה',
  'assets.ownerSchedule.bookingCount': '{n} הזמנות לנכס זה',
  'assets.ownerSchedule.noBookings': 'אין הזמנות ביום זה.',
  'assets.ownerSchedule.unknownBooker': 'אורח לא ידוע',
  'assets.ownerSchedule.peopleCount': '{n} אנשים',
  'assets.ownerSchedule.loadError': 'לא ניתן לטעון הזמנות לנכס זה.',
  'assets.ownerSchedule.legendTitle': 'מקרא לוח שנה',
  'assets.ownerSchedule.legendClosed': 'סגור',
  'assets.ownerSchedule.legendOpenEmpty': 'פתוח (ללא הזמנות)',
  'assets.ownerSchedule.legendOpenBookings': 'פתוח (עם הזמנות)',
  'assets.ownerSchedule.legendBlackout': 'חסימה',
  'assets.ownerSchedule.dayClosed': 'יום זה סגור או חסום.',

  'bookings.title': 'הזמנות',
  'bookings.apiLabel': 'ממשק הזמנות',
  'bookings.formNav': 'ניווט טופס הזמנה',
  'bookings.operation.getById': 'הזמנה לפי מזהה',
  'bookings.operation.listAll': 'ההזמנות שלי',
  'bookings.operation.create': 'יצירת הזמנה',
  'bookings.operation.modifyPrice': 'שינוי מחיר',
  'bookings.operation.cancelClient': 'ביטול (לקוח)',
  'bookings.operation.cancelOwner': 'ביטול (בעלים)',
  'bookings.operation.escalate': 'הסלמה לתמיכה',
  'bookings.howMany': 'כמה',
  'bookings.howManyHours': 'מספר שעות',
  'bookings.startFixed': 'התחלה (קבוע)',
  'bookings.endCalculated': 'סיום (מחושב)',
  'bookings.periodEndRoundedUp':
    'תאריך הסיום עוגל למעלה ל-{end} ({periods}) כדי להתאים למחזורי חיוב שלמים.',
  'bookings.totalPriceCalculated': 'מחיר כולל (מחושב)',
  'bookings.numberOfPeople': 'מספר אנשים',
  'bookings.bookingPeriod': 'תקופת הזמנה',
  'bookings.pricing': 'תמחור',
  'bookings.optionalAddons': 'תוספות אופציונליות',
  'bookings.cancelEdit': 'ביטול עריכה',
  'bookings.cancelBooking': 'ביטול הזמנה',
  'bookings.cancelSuccess': 'ההזמנה בוטלה.',
  'bookings.cancelOrphanSuccess':
    'ההזמנה הוסרה מהרשימה שלכם. המקום המקושר אינו זמין עוד ולכן לא ניתן היה לבטל אותה בשרת.',
  'bookings.backToList': 'חזרה לרשימה',
  'bookings.backToBookings': 'חזרה להזמנות',
  'bookings.backToAssetsLabel': '→ חזרה לנכסים',
  'bookings.backToBookingsLabel': '→ חזרה להזמנות',
  'bookings.placeholderUuid': 'UUID',
  'bookings.calendar.title': 'בחירת תאריכים',
  'bookings.calendar.titleHourly': 'בחירת יום ושעה',
  'bookings.calendar.titleExtend': 'לוח זמינות',
  'bookings.calendar.hint': 'בחר התחלה או סיום, ואז הקש על יום בלוח. ימים מפוספסים שמורים.',
  'bookings.calendar.hintHourly':
    'הקש על יום בלוח, ואז בחר שעת התחלה ומספר שעות.',
  'bookings.calendar.hintExtend':
    'הקש על יום כדי להאריך את תאריך הסיום. ימים מפוספסים שמורים להזמנות אחרות.',
  'bookings.calendar.hintHourlyExtend':
    'שנה את מספר השעות למטה כדי להאריך את ההזמנה. ימים מפוספסים שמורים.',
  'bookings.calendar.startDate': 'תאריך התחלה',
  'bookings.calendar.selectedDay': 'יום',
  'bookings.calendar.endDate': 'תאריך סיום',
  'bookings.calendar.notSelected': 'לא נבחר',
  'bookings.calendar.pickStart': 'בחר תאריך התחלה',
  'bookings.calendar.pickEnd': 'בחר תאריך סיום',
  'bookings.calendar.pickEndNeedsStart': 'בחר תחילה תאריך התחלה.',
  'bookings.calendar.startTime': 'שעת התחלה',
  'bookings.calendar.endTime': 'שעת סיום',
  'bookings.calendar.hourlyHint': 'קבע את השעה לכל תקופה (לאחר בחירת התאריכים).',
  'bookings.calendar.hourlySameDayHint':
    'בחר שעת התחלה. שעת הסיום מחושבת לפי מספר השעות.',
  'bookings.calendar.endTimeAuto': 'בחר מספר שעות למטה',
  'bookings.calendar.reservedLegend': 'שמור',
  'bookings.calendar.closedLegend': 'סגור / חסימה',
  'bookings.calendar.rangeLegend': 'הבחירה שלך',
  'bookings.calendar.prevMonth': 'חודש קודם',
  'bookings.calendar.nextMonth': 'חודש הבא',
  'bookings.calendar.loading': 'טוען הזמנות…',
  'bookings.calendar.rangeBlocked': 'טווח התאריכים כולל ימים שמורים — בחר תאריכים אחרים.',

  'bookings.scheduleError.chooseStart': 'בחר/י תאריך ושעת התחלה.',
  'bookings.scheduleError.chooseEnd': 'בחר/י תאריך ושעת סיום.',
  'bookings.scheduleError.invalidDates': 'תאריכי ההתחלה והסיום חייבים להיות תקינים.',
  'bookings.scheduleError.endBeforeStart': 'תאריך הסיום חייב להיות אחרי ההתחלה.',
  'bookings.scheduleError.startTooSoon':
    'שעת ההתחלה מוקדמת מדי — בחר/י שעה לפחות כמה דקות מהעכשיו.',
  'bookings.scheduleError.hourlySameDay': 'הזמנה לפי שעה חייבת להתחיל ולהסתיים באותו יום.',
  'bookings.scheduleError.hourlySameDayEnd': 'הזמנה לפי שעה חייבת להסתיים באותו יום כמו ההתחלה.',
  'bookings.scheduleError.startTooLateToday':
    'שעת ההתחלה מאוחרת מדי — לא נשאר מספיק זמן היום להזמנה לפי שעה.',
  'bookings.scheduleError.startInPast': 'תאריך ההתחלה לא יכול להיות בעבר.',
  'bookings.scheduleError.missingBookingStart':
    'חסר תאריך התחלה להזמנה — טען/י מחדש את ההזמנה ונסה/י שוב.',
  'bookings.scheduleError.invalidEnd': 'תאריך הסיום חייב להיות תקין.',
  'bookings.scheduleError.endBeforeBookingStart': 'תאריך הסיום חייב להיות אחרי תחילת ההזמנה.',
  'bookings.scheduleError.periodAlign': 'תאריך הסיום חייב להתאים לתקופות הזמנה שלמות.',
  'bookings.scheduleError.cannotShortenBelow': 'לא ניתן לקצר מתחת ל-{periods}.',
  'bookings.scheduleError.periodCountMismatch':
    'תאריך הסיום חייב להתאים למספר התקופות ({periods}) מתחילת ההזמנה.',

  'bookings.titleUpdate': 'עדכון הזמנה',
  'bookings.titleCreate': 'יצירת הזמנה',
  'bookings.extendLegend': 'הארכת הזמנה',
  'bookings.paymentOption': 'אפשרות תשלום:',
  'bookings.periodStartPlus': 'התחלה + {period}',
  'bookings.totalPriceBasedOn':
    'מבוסס על {pricing} ב-{price} לתקופה בתוספת התוספות שנבחרו.',
  'bookings.totalPriceBasedOnNoUnit': 'מבוסס על {pricing} בתוספת התוספות שנבחרו.',
  'bookings.totalPriceHintEnd':
    'קבע/י סיום אחרי ההתחלה וודא/י שלנכס יש מחיר לתקופת ההזמנה.',
  'bookings.loadingAssetRates': 'טוען תעריפי נכס…',
  'bookings.loadingOptions': 'טוען אפשרויות הזמנה מהנכס…',
  'bookings.schedule': 'לוח זמנים',
  'bookings.startDate': 'תאריך התחלה',
  'bookings.startDateTime': 'תאריך ושעת התחלה',
  'bookings.startLegend': 'התחלה',
  'bookings.endLegend': 'סיום',
  'bookings.addonsLegend': 'תוספות',
  'bookings.noBookingsListed': 'אין הזמנות ברשימה',
  'bookings.noUpcomingBookingsListed': 'אין הזמנות נוכחיות',
  'bookings.noPastBookingsListed': 'אין הזמנות בהיסטוריה',
  'bookings.list.timeFilterLabel': 'רשימת הזמנות',
  'bookings.list.timeFilterCurrent': 'הזמנות נוכחיות',
  'bookings.list.timeFilterPast': 'היסטורית הזמנות',
  'bookings.discardEdit': 'לבטל את השינויים להזמנה זו?',
  'bookings.discardCreate': 'לבטל את ההזמנה?',
  'bookings.couldNotCalculateTotal':
    'לא ניתן לחשב מחיר כולל — בדוק/י שתאריך הסיום אחרי ההתחלה ושתעריפי הנכס נטענו.',
  'bookings.error.assetNotBookable':
    'לא ניתן עוד להזמין את המקום הזה. ייתכן שהוסר או הורד מהרשימה. חזרו לדפדוף ובחרו מקום אחר.',
  'bookings.error.assetLoadSession':
    'לא ניתן לאמת את ההתחברות. היכנסו שוב, ואז נסו להזמין מחדש.',
  'bookings.error.assetLoadIpMismatch':
    'ההתחברות קשורה לכתובת רשת אחרת. היכנסו שוב מהדפדפן הזה, ואז נסו שוב.',
  'bookings.error.peopleExceedsCapacity':
    'מספר האנשים המבוקש חורג מהקיבולת הזמינה ({capacity}) לתאריכים שנבחרו',
  'bookings.error.roleNotAllowed':
    'לחשבון שלך אין הרשאה ליצור הזמנות. רק לקוחות פרטיים ועובדי עסק יכולים להזמין מקומות.',
  'bookings.error.roleNotAllowedHint':
    'אם התחברתם עם Google, ייתכן שהשרת יצר את החשבון בלי תפקיד לקוח פרטי. התנתקו, הירשמו כלקוח פרטי עם אימייל וסיסמה (או השתמשו בחשבון Google אחר), או בקשו מהתמיכה לתקן את תפקיד החשבון. אל תשתמשו בשני חלונות דפדפן על אותו localhost לבעלים וללקוח — הם חולקים אותה התחברות.',
  'bookings.error.completeRegistration': 'יש להשלים את הרישום לפני ההזמנה.',
  'bookings.error.completeRegistrationServer.title': 'ההזמנה נחסמה בשרת',
  'bookings.error.completeRegistrationServer.body':
    'בפרופיל כבר יש שם, אימייל, טלפון ותאריך לידה. שירות ההזמנות עדיין דוחה את הבקשה כרישום לא הושלם. הדגל הזה נמצא בשרת, לא באפליקציה — יש לבקש מהתמיכה לנקות מצב רישום חלקי עבור חשבון Google זה.',
  'bookings.error.completeRegistrationServer.hint':
    'GET /profile מלא; POST /bookings/create עדיין מחזיר “Complete registration before booking”. מילוי הטופס שוב לא יפתור את זה.',
  'bookings.error.profileAuth.title': 'היכנסו שוב כדי להזמין',
  'bookings.error.profileAuth.session':
    'לא ניתן לאמת את ההתחברות. היכנסו שוב מהדפדפן הזה ונסו להזמין מחדש.',
  'bookings.error.profileAuth.ipMismatch':
    'ההתחברות קשורה לכתובת רשת אחרת. כבו VPN אם אתם משתמשים בו, והיכנסו שוב מהדפדפן הזה.',
  'bookings.error.profileAuth.signInAgain': 'היכנסו שוב',
  'bookings.error.roleBlock.title': 'לא ניתן להזמין עם חשבון זה',
  'bookings.error.roleBlock.assetOwner':
    'התחברתם כבעל/ת נכס. בעלי נכסים מנהלים מודעות; הם לא יכולים להזמין מקומות כלקוחות.',
  'bookings.error.roleBlock.businessClient':
    'התחברתם כלקוח עסקי. סוג חשבון זה לא יכול ליצור הזמנות באפליקציה.',
  'bookings.error.roleBlock.profileRole':
    'פרופיל Placy שלכם אינו חשבון לקוח להזמנה (למשל לקוח עסקי או בעל נכס).',
  'bookings.error.roleBlock.serverRole':
    'התחברתם כלקוח פרטי באפליקציה, אך השרת הקצה לחשבון role_id {roleId} שלא יכול ליצור הזמנות. לקוחות פרטיים צריכים role_id 1 (או 3 לעובדי עסק).',
  'bookings.error.roleBlock.jwtClaims': 'תביעות תפקיד בטוקן: {claims}',
  'bookings.error.roleBlock.loginType':
    'סוג התחברות זה לא יכול ליצור הזמנות. התחברו כלקוח פרטי או עובד עסקי.',
  'bookings.period.hour.one': 'שעה אחת',
  'bookings.period.hour.other': '{count} שעות',
  'bookings.period.day.one': 'יום אחד',
  'bookings.period.day.other': '{count} ימים',
  'bookings.period.week.one': 'שבוע אחד',
  'bookings.period.week.other': '{count} שבועות',
  'bookings.period.month.one': 'חודש אחד',
  'bookings.period.month.other': '{count} חודשים',
  'bookings.period.year.one': 'שנה אחת',
  'bookings.period.year.other': '{count} שנים',
  'bookings.addon.available.one': 'זמין 1',
  'bookings.addon.available.upTo': 'עד {max} זמינים',
  'bookings.addon.onBooking.noneLeft.one': '1 בהזמנה זו (אין עוד להוספה)',
  'bookings.addon.onBooking.noneLeft': '{count} בהזמנה זו (אין עוד להוספה)',
  'bookings.addon.onBooking.more.one': '{reserved} בהזמנה · עוד 1 זמין',
  'bookings.addon.onBooking.more': '{reserved} בהזמנה · עוד {more} זמינים',
  'bookings.list.pendingUpdateOnly': 'ניתן לעדכן רק הזמנות ממתינות.',
  'bookings.list.pendingCancelOnly': 'ניתן לבטל רק הזמנות ממתינות.',
  'bookings.list.pastUpdateOnly': 'לא ניתן לעדכן הזמנות שעברו.',
  'bookings.list.pastCancelOnly': 'לא ניתן לבטל הזמנות שעברו.',
  'bookings.list.updateAria': 'עדכון הזמנה עבור {name}',
  'bookings.list.updateBlockedAria': 'לא ניתן לעדכן את {name} (לא ממתין)',
  'bookings.list.updateBlockedPastAria': 'לא ניתן לעדכן את {name} (הזמנה שעברה)',
  'bookings.list.cancelAria': 'ביטול הזמנה עבור {name}',
  'bookings.list.cancelBlockedAria': 'לא ניתן לבטל את {name} (לא ממתין)',
  'bookings.list.cancelBlockedPastAria': 'לא ניתן לבטל את {name} (הזמנה שעברה)',
  'bookings.viewAsset': 'צפייה בנכס',
  'bookings.viewAssetAria': 'צפייה בנכס של {name}',
  'bookings.confirmation.title': 'הזמנתך בוצעה בהצלחה',
  'bookings.confirmation.subtitle': 'יש לסרוק/להציג את הברקוד',
  'bookings.confirmation.schedule': 'תאריך ושעה',
  'bookings.confirmation.peopleLabel': 'מספר אורחים',
  'bookings.confirmation.vehicleLabel': 'רכב',
  'bookings.confirmation.bookingId': 'מזהה הזמנה',
  'bookings.parkingVehicle.title': 'בחרו רכב',
  'bookings.parkingVehicle.intro':
    'להזמנת חניון נדרש רכב רשום. המשיכו עם הרכב הראשי, בחרו רכב אחר להזמנה זו בלבד, או ערכו את הרשימה.',
  'bookings.parkingVehicle.continuePrimary': 'המשך עם הרכב הראשי',
  'bookings.parkingVehicle.continueSelected': 'המשך עם הרכב שנבחר',
  'bookings.parkingVehicle.editList': 'עריכת רשימת רכבים',
  'bookings.parkingVehicle.saveCars': 'שמירת רכבים',
  'bookings.parkingVehicle.backToList': 'חזרה לרשימה',
  'bookings.parkingVehicle.cancel': 'ביטול',
  'bookings.parkingVehicle.none': 'הוסיפו לפחות רכב אחד כדי להמשיך.',
  'bookings.parkingVehicle.required': 'בחרו רכב להזמנת החניון.',
  'bookings.confirmation.showBarcode': 'הצג ברקוד',
  'bookings.confirmation.hideBarcode': 'הסתר ברקוד',
  'bookings.confirmation.venueLoading': 'טוען פרטי מכון…',
  'bookings.confirmation.venueUnknown': 'מכון',
  'bookings.confirmation.qrCaption': 'יש להציג קוד זה בכניסה למכון',
  'bookings.confirmation.loading': 'מכין את האישור…',
  'bookings.confirmation.popupBlocked':
    'הדפדפן חסם את חלון האישור — הפרטים מוצגים למטה.',
  'bookings.confirmation.close': 'סגירה',
  'bookings.calendarExport.groupLabel': 'הוספה ליומן',
  'bookings.calendarExport.addToGoogle': 'הוספה ל-Google Calendar',
  'bookings.calendarExport.downloadIcs': 'הורדת קובץ .ics',
  'bookings.viewConfirmation': 'הצגת אישור',
  'bookings.viewConfirmationAria': 'הצגת אישור עבור {name}',
  'bookings.myBookings': 'ההזמנות שלי',
  'bookings.cancellationPolicy.title': 'מדיניות ביטולים',
  'bookings.cancellationPolicy.ruleWeek': 'עד שבוע לפני — החזר מלא',
  'bookings.cancellationPolicy.ruleDay': 'עד 24 שעות לפני — החזר של 50%',
  'bookings.cancellationPolicy.ruleLate': 'פחות מ-24 שעות לפני — ללא החזר',
  'bookings.cancellationPolicy.agreeLabel': 'קראתי ואני מסכים/ה למדיניות הביטולים',
  'bookings.cancellationPolicy.continue': 'המשך לתשלום',
  'bookings.cancellationPolicy.cancel': 'ביטול',
  'gymHealth.title': 'הצהרת בריאות',
  'gymHealth.intro':
    'כדי להירשם לפעילויות, צריך למלא באופן חד-פעמי את הצהרת הבריאות למתאמנים:',
  'gymHealth.q.gender': '1. מה המגדר שלך?',
  'gymHealth.gender.male': 'גבר',
  'gymHealth.gender.female': 'אישה',
  'gymHealth.gender.other': 'לא משנה לי',
  'gymHealth.q.birthDate': '2. מה תאריך הלידה שלך?',
  'gymHealth.q.heartDisease': 'האם הרופא שלך אמר לך שאת/ה סובל/ת ממחלות לב?',
  'gymHealth.q.chestPainRest': 'האם את/ה חש/ה כאבים בחזה בזמן מנוחה?',
  'gymHealth.q.chestPainDaily': 'האם את/ה חש/ה כאבים בחזה במהלך פעילויות שיגרה ביום-יום?',
  'gymHealth.q.chestPainExercise': 'האם את/ה חש/ה כאבים בחזה בזמן שאת/ה מבצע/ת פעילות גופנית?',
  'gymHealth.q.dizziness': 'האם במהלך השנה החולפת איבדת שיווי משקל עקב סחרחורת?',
  'gymHealth.q.consciousness': 'האם במהלך השנה החולפת איבדת את הכרתך?',
  'gymHealth.q.asthma':
    'האם רופא אבחן שאת/ה סובל/ת ממחלת האסתמה ולכן בשלושת החודשים האחרונים סבלת מקוצר נשימה או ציפצופים?',
  'gymHealth.q.familyHeart': 'האם אחד מבני משפחתך מדרגת קרבה ראשונה נפטר ממחלת לב?',
  'gymHealth.q.familySuddenDeath':
    'האם אחד מבני משפחתך מדרגת קרבה ראשונה נפטר ממוות פתאומי בגיל מוקדם? (לפני גיל 55 אם מדובר בגבר, ולפני גיל 65 אם זו אישה)',
  'gymHealth.q.doctorSupervision':
    'האם הרופא שלך אמר לך ב-5 השנים האחרונות לבצע פעילות גופנית רק תחת השגחה רפואית?',
  'gymHealth.q.chronicOther':
    'האם הינך סובל/ת ממחלה קבועה (כרונית) שאינה נזכרת בשאלות לעיל ועשויה למנוע או להגביל אותך בביצוע פעילות גופנית?',
  'gymHealth.q.pregnancyRisk':
    'לנשים בהריון: האם ההריון הזה או כל הריון קודם הוגדר כהריון בסיכון?',
  'gymHealth.q.smoker': 'האם את/ה מעשן/ת?',
  'gymHealth.instructionsTitle': 'הנחיות',
  'gymHealth.instruction1':
    'אם התשובה לאחת השאלות תצביע על בעיה רפואית, נצטרך לבקש ממך להעביר לנו "אישור רפואי למתאמן" שמבקשים מרופא המשפחה שלך.',
  'gymHealth.instruction2':
    'בכל מקרה של שינוי במצב הבריאותי שלך יש להתייעץ עם רופא לגבי המשך הפעילות הגופנית שלך.',
  'gymHealth.declarationTitle': 'הצהרה',
  'gymHealth.declarationBody':
    'אני מצהיר/ה כי קראתי והבנתי את כל השאלון הרפואי וכל התשובות לשאלות בטופס זה הן מלאות ונכונות. אני מצהיר/ה כי מסרתי ידיעות מלאות ונכונות על מצבי הרפואי בעבר ובהווה לפי השאלות שנשאלתי בשאלון האמור. ידוע לי כי לאחר שנה מיום חתימתי על הצהרת בריאות זו יהיה עליי להמציא הצהרת בריאות חדשה. התועלת הבריאותית של פעילות גופנית סדירה ברורה; השאלון יבהיר לך באילו מקרים יש להתייעץ עם הרופא/ה ולהביא אישור רפואי לפני התחלת האימון.',
  'gymHealth.declarationAgree': 'אישרתי את ההצהרה',
  'gymHealth.submit': 'שלח',
  'gymHealth.cancel': 'ביטול',
  'gymHealth.submitError': 'לא ניתן לשמור את הצהרת הבריאות. נסו שוב.',
  'bookings.payment.title': 'תשלום',
  'bookings.payment.subtitle': 'בחרו איך לשלם והשלימו את ההזמנה.',
  'bookings.payment.methodLegend': 'אמצעי תשלום',
  'bookings.payment.methodCard': 'כרטיס',
  'bookings.payment.methodBit': 'ביט',
  'bookings.payment.methodPaypal': 'PayPal',
  'bookings.payment.subtitleCard': 'הזינו את פרטי הכרטיס כדי להשלים את ההזמנה.',
  'bookings.payment.subtitleCardPayplus':
    'תשלום בכרטיס ממשיך בדף המאובטח של PayPlus — אין צורך להזין פרטי כרטיס כאן.',
  'bookings.payment.subtitleBit': 'שלמו באמצעות ביט עם מספר הנייד שלכם.',
  'bookings.payment.subtitlePaypal': 'שלמו עם חשבון PayPal שלכם.',
  'bookings.payment.amountDue': 'סכום לתשלום',
  'bookings.payment.vatIncluded': 'כולל מע״מ 18%',
  'bookings.payment.cardName': 'שם בעל הכרטיס',
  'bookings.payment.cardNamePlaceholder': 'השם שעל הכרטיס',
  'bookings.payment.cardNumber': 'מספר כרטיס',
  'bookings.payment.expiry': 'תוקף (MM/YY)',
  'bookings.payment.cvc': 'CVC',
  'bookings.payment.pay': 'תשלום {amount}',
  'bookings.payment.payNoAmount': 'תשלום',
  'bookings.payment.cancel': 'ביטול',
  'bookings.payment.processing': 'מעבד…',
  'bookings.payment.secureNote': 'לאחר לחיצה על תשלום תועברו להשלמת התשלום באופן מאובטח ב־PayPlus.',
  'bookings.payplus.processingTitle': 'מאשרים את התשלום…',
  'bookings.payplus.processingBody':
    'ממתינים לאישור התשלום מ־PayPlus. זה בדרך כלל לוקח כמה שניות.',
  'bookings.payplus.processingHint': 'אפשר להשאיר את המסך פתוח — נרענן אוטומטית.',
  'bookings.payplus.confirmedTitle': 'התשלום אושר',
  'bookings.payplus.confirmedBody': 'ההזמנה אושרה. תודה!',
  'bookings.payplus.failedTitle': 'התשלום נכשל',
  'bookings.payplus.failedBody':
    'לא ניתן להשלים את החיוב ב־PayPlus. ההזמנה עדיין ממתינה — אפשר לנסות לשלם שוב מ«ההזמנות שלי».',
  'bookings.payplus.cancelledTitle': 'התשלום בוטל',
  'bookings.payplus.cancelledBody':
    'יצאתם מדף התשלום. ההזמנה עדיין ממתינה עד להשלמת התשלום.',
  'bookings.payplus.backToBookings': 'חזרה להזמנות שלי',
  'bookings.payplus.keepWaiting': 'המשך להמתין',
  'bookings.payplus.awaitingTitle': 'נדרש תשלום',
  'bookings.payplus.awaitingBody':
    'ההזמנה ממתינה עד שהתשלום יצליח. השלימו את התשלום ב־PayPlus כדי לאשר אותה.',
  'bookings.payplus.payNow': 'תשלום ב־PayPlus',
  'bookings.payplus.testChargeNotice':
    'זוהה כרטיס בדיקה של PayPlus — החיוב על ההזמנה יהיה ₪1 בלבד (מגבלת סנדבוקס עד ₪5).',
  'bookings.payplus.redirectError': 'לא ניתן לפתוח את תשלום PayPlus. נסו שוב.',
  'bookings.payment.savedCardsLegend': 'כרטיסים שמורים',
  'bookings.payment.useNewCard': 'שימוש בכרטיס אחר',
  'bookings.payment.usingSavedCard': 'תשלום עם •••• {last4} ({name})',
  'bookings.payment.errorName': 'הזינו את שם בעל הכרטיס.',
  'bookings.payment.errorNameInvalid': 'הזינו שם תקין (לפחות 2 אותיות).',
  'bookings.payment.errorNumber': 'הזינו מספר כרטיס תקין (13–19 ספרות).',
  'bookings.payment.errorNumberLuhn': 'הזינו מספר כרטיס אשראי תקין.',
  'bookings.payment.errorExpiry': 'הזינו תאריך תוקף תקין (MM/YY).',
  'bookings.payment.errorExpiryPast': 'תוקף הכרטיס פג.',
  'bookings.payment.errorCvc': 'הזינו CVC תקין.',
  'bookings.payment.errorBookingFailed':
    'התשלום התקבל אך לא ניתן ליצור את ההזמנה. נסו שוב.',
  'bookings.payment.nationalId': 'תעודת זהות',
  'bookings.payment.nationalIdPlaceholder': '9 ספרות',
  'bookings.payment.errorNationalId': 'הזינו מספר תעודת זהות תקין (9 ספרות).',
  'bookings.payment.bitPhone': 'מספר נייד',
  'bookings.payment.bitPhonePlaceholder': '05X-XXXXXXX',
  'bookings.payment.errorBitPhone': 'הזינו מספר נייד ישראלי תקין.',
  'bookings.payment.paypalEmail': 'דוא״ל PayPal',
  'bookings.payment.paypalEmailPlaceholder': 'you@email.com',
  'bookings.payment.errorPaypalEmail': 'הזינו כתובת דוא״ל תקינה.',

  'bookings.workerCredits.title': 'תשלום בקרדיטים מהמעסיק',
  'bookings.workerCredits.subtitle':
    'שלמו בקרדיטים שהמעסיק הקצה לכם. הזינו את מספר תעודת הזהות ואת ח.פ. של המעסיק.',
  'bookings.workerCredits.nationalId': 'מספר תעודת זהות',
  'bookings.workerCredits.businessId': 'ח.פ. של המעסיק',
  'bookings.workerCredits.businessIdPlaceholder': 'מספר ח.פ.',
  'bookings.workerCredits.pay': 'תשלום בקרדיטים {amount}',
  'bookings.workerCredits.payNoAmount': 'תשלום בקרדיטים',
  'bookings.workerCredits.openRegularPayment': 'תשלום בכרטיס, ביט או PayPal במקום',
  'bookings.workerCredits.otpSoon': 'אימות SMS יתווסף כאן בעדכון עתידי.',
  'bookings.workerCredits.errorNationalId': 'הזינו מספר תעודת זהות תקין (9 ספרות).',
  'bookings.workerCredits.errorBusinessId': 'הזינו ח.פ. תקין של המעסיק.',
  'bookings.walletCredits.pay': 'תשלום מיתרת הארנק {amount}',
  'bookings.walletCredits.payNoAmount': 'תשלום מיתרת הארנק',
  'bookings.walletCredits.method': 'ארנק',
  'bookings.walletCredits.subtitle': 'שלמו על הזמנה זו מיתרת הקרדיטים בארנק.',
  'bookings.walletCredits.balance': 'יתרת ארנק: {amount}',
  'bookings.walletCredits.hint': 'הקרדיטים ינוכו בעת יצירת ההזמנה.',
  'bookings.walletCredits.secureNote': 'משתמש ביתרת הארנק של Placy (עיגול למעלה של הסכום לתשלום).',

  'profile.title': 'פרופיל',
  'profile.completion.title': 'השלימו את הפרופיל כדי להזמין',
  'profile.completion.intro':
    'הפרטים המסומנים חסרים או עדיין מכילים ערכי ברירת מחדל. עדכנו אותם כדי להמשיך בהזמנה.',
  'profile.completion.loading': 'טוען את הפרופיל…',
  'profile.completion.success': 'הפרופיל עודכן — אפשר להמשיך בהזמנה.',
  'profile.completion.saveFailed':
    'לא ניתן לשמור את הפרופיל בשרת. בדקו את החיבור ונסו שוב.',
  'profile.completion.successLocalOnly':
    'הפרטים נשמרו במכשיר זה. השרת לא עדכן אימייל או טלפון (כבר רשומים) — אפשר להמשיך בהזמנה.',
  'profile.completion.successPartial':
    'הפרופיל עודכן. חלק מפרטי הקשר לא עודכנו בשרת — אפשר להמשיך בהזמנה.',
  'profile.completion.serverStillIncomplete':
    'השרת עדיין שומר פרטי רישום חסרים. בחרו מדינה, אשרו את התנאים ונסו שוב.',
  'profile.completion.submit': 'השלמת פרופיל',
  'profile.hub.nameLabel': 'שם',
  'profile.hub.settings': 'הגדרות',
  'profile.hub.userProfile': 'פרופיל משתמש',
  'profile.hub.payment': 'תשלום',
  'profile.hub.terms': 'תנאים והגבלות',
  'profile.hub.termsClientHeading': 'תנאים והגבלות',
  'profile.hub.termsContactPrefix': 'שאלות? שלחו דוא"ל ל',
  'profile.hub.termsViewOnWeb': 'צפייה בתנאים המלאים באתר offizz.ai',
  'platform.termsAgree': 'אני מסכים/ה לתנאים וההגבלות',
  'platform.termsAgreeTermsOfUse': 'אני מסכים/ה לתנאי השימוש',
  'platform.termsAgreePrivacyPolicy': 'אני מסכים/ה למדיניות הפרטיות',
  'platform.termsAgreeAccessibility': 'אני מסכים/ה להצהרת הנגישות',
  'platform.termsRequired': 'יש לאשר את התנאים וההגבלות לפני המשך.',
  'platform.termsRequiredAll':
    'יש לאשר את תנאי השימוש, מדיניות הפרטיות והצהרת הנגישות לפני המשך.',
  'profile.hub.contact': 'צור קשר',
  'profile.hub.contactGmail': 'פתיחה ב-Gmail',
  'profile.hub.contactCopyEmail': 'העתקת מייל',
  'profile.hub.contactCopied': 'הועתק',
  'profile.hub.language': 'שפה',
  'profile.hub.followUs': 'עקבו אחרינו',
  'profile.hub.logout': 'התנתק',
  'profile.hub.eraseAccount': 'מחיקת חשבון',
  'profile.hub.deleteAccountSummary':
    'החשבון מושבת מיד ונמחק לצמיתות תוך 30 יום: פרופיל, פרטי התחברות, מועדפים, היסטוריה, כרטיסים שמורים והודעות שאינן קשורות להזמנה. רשומות הזמנות, חשבוניות ותשלומים (כולל השם ופרטי הקשר שבהן) נשמרות 7 שנים לצורכי מס ומחלוקות. יש לבטל או לסיים הזמנות עתידיות לפני המחיקה.',
  'profile.hub.deleteAccountDetails': 'פירוט מלא: מה נמחק ומה נשמר',
  'profile.hub.deleteAccountButton': 'מחק את החשבון שלי',
  'profile.hub.paymentSoon': 'הגדרות תשלום יהיו זמינות כאן בקרוב.',
  'profile.hub.paymentNotSet': 'עדיין לא הוגדר חשבון בנק.',
  'profile.hub.paymentUpdated': 'פרטי התשלום נשמרו.',
  'profile.hub.detailsUpdated': 'הפרטים נשמרו.',
  'profile.hub.notImplemented': 'אפשרות זו עדיין לא זמינה.',
  'profile.hub.eraseConfirm':
    'למחוק את חשבון PLACY? תנותקו עכשיו והחשבון יימחק לצמיתות תוך 30 יום. רשומות הזמנות ותשלומים נשמרות 7 שנים כנדרש בחוק. לביטול הבקשה תוך 30 יום, כתבו אל info@offizz.ai.',
  'profile.hub.back': 'חזרה לפרופיל',
  'profile.hub.shieldAria': 'אבטחת חשבון',
  'profile.hub.editProfile': 'ערוך פרופיל',
  'profile.hub.editVehicles': 'עריכת רכבים',
  'profile.hub.editPayment': 'ערוך פרטי תשלום',
  'profile.hub.detailsTitle': 'הפרטים שלך',
  'profile.hub.paymentMethods': 'אמצעי תשלום',
  'profile.hub.editPaymentMethods': 'עריכת אמצעי תשלום',
  'profile.hub.paymentMethodsUpdated': 'אמצעי התשלום נשמר.',
  'profile.paymentMethods.notSet': 'עדיין לא הוגדר כרטיס אשראי.',
  'profile.paymentMethods.cardIntro': 'הוסיפו עד 3 כרטיסי אשראי להזמנות.',
  'profile.paymentMethods.onFile': 'כרטיס שמור: {last4}',
  'profile.paymentMethods.empty': 'עדיין לא נוספו כרטיסים.',
  'profile.paymentMethods.add': 'הוסף כרטיס',
  'profile.paymentMethods.saveCard': 'שמירת כרטיס',
  'profile.paymentMethods.remove': 'הסר',
  'profile.paymentMethods.primary': 'ראשי',
  'profile.paymentMethods.setPrimary': 'הגדר כראשי',
  'profile.paymentMethods.maxReached': 'ניתן לשמור עד 3 כרטיסים.',
  'profile.paymentMethods.errorMax': 'ניתן להוסיף עד 3 כרטיסים.',
  'profile.paymentMethods.errorDuplicate': 'כרטיס זה כבר שמור.',
  'profile.paymentMethods.secureNote':
    'הצהרה: כל פרטי הכרטיס שתזינו נשמרים במכשיר זה בלבד. הם אינם נשמרים בשרתי החברה.',
  'profile.hub.buildInfoAria': 'גרסת האפליקציה וסביבת הריצה',
  'profile.hub.profileLastUpdated': 'עודכן לאחרונה {date}',
  'profile.hub.profileLastUpdatedUnknown': 'עודכן לאחרונה: לא נרשם עדיין',
  'profile.hub.buildInfoEnvironment': 'סביבה',
  'profile.hub.buildInfoUpdated': 'עדכון אחרון',
  'profile.hub.buildInfoVersion': 'גרסה',
  'profile.hub.buildInfoPlayVersion': 'Google Play',
  'profile.hub.buildInfoUnknown': 'לא ידוע',
  'profile.hub.employerManaged': 'מנוהל על ידי המעסיק',
  'profile.hub.workerProfileReadOnly':
    'המעסיק/ה מנהל/ת את השם, הטלפון ושאר פרטי הפרופיל. ניתן לעדכן את תמונת הפרופיל באמצעות כפתור המצלמה על האווטאר למעלה.',
  'profile.hub.workerPhotoReadOnly':
    'תמונת הפרופיל מנוהלת על ידי המעסיק. לשינוי — פנו למנהל/ת.',
  'profile.hub.workerPhotoUpdated': 'תמונת הפרופיל עודכנה.',
  'profile.hub.workerPhotoUploadFailed':
    'לא ניתן לשמור את התמונה. ייתכן שהשרת עדיין חוסם עדכוני פרופיל לעובדים — נדרש לאפשר PATCH /profile עם profile_image לעובדי עסק (role_id 3).',
  'profile.hub.photoUploadFailed': 'לא ניתן להעלות את תמונת הפרופיל. לעת עתה היא נשמרת במכשיר זה בלבד.',
  'profile.hub.accountType': 'סוג חשבון',
  'profile.hub.serverRoleId': 'תפקיד בשרת (role_id)',
  'profile.field.firstName': 'שם פרטי',
  'profile.field.lastName': 'שם משפחה',
  'profile.field.cellPhone': 'טלפון נייד',
  'profile.field.email': 'דוא"ל',
  'profile.field.dateOfBirth': 'תאריך לידה',
  'profile.field.occupation': 'עיסוק',
  'profile.field.ownerLogo': 'לוגו עסק',
  'profile.field.employeeRegistrationCode': 'קוד רישום לעובדים',
  'profile.field.workerRegistrationCode': 'קוד רישום לעובדים',
  'profile.field.availableCredits': 'קרדיטים זמינים',
  'profile.hub.walletCredits': '{amount} קרדיטים',
  'profile.hub.walletCreditsAria': 'קרדיטים זמינים: {amount}',
  'profile.hub.myWallet': 'הארנק שלי',
  'profile.hub.loadCredits': 'טען קרדיטים',
  'profile.hub.loadCreditsWalletBtn': 'טען\nקרדיטים',
  'profile.hub.loadCreditsButton': 'טען',
  'profile.hub.loadCreditsTitle': 'טעינת קרדיטים',
  'profile.hub.loadCreditsIntro':
    'בחרו חבילת קרדיטים או הזינו סכום חופשי, ואז שלמו כדי\u202Fלהוסיף ליתרה.',
  'profile.hub.loadCreditsBalance': 'יתרה נוכחית: {amount}',
  'profile.hub.loadCreditsChoose': 'בחירת חבילה',
  'profile.hub.loadCreditsPackCredits': '{count} קרדיטים',
  'profile.hub.loadCreditsCustom': 'סכום חופשי',
  'profile.hub.loadCreditsCustomAmount': 'הזינו סכום',
  'profile.hub.loadCreditsCustomPlaceholder': 'לדוגמה 750',
  'profile.hub.loadCreditsCustomInvalid': 'הזינו סכום תקין של לפחות ₪1.',
  'profile.hub.loadCreditsContinue': 'המשך לתשלום',
  'profile.field.availableCreditsHint':
    'יתרת הקרדיטים מגיעה מהמעסיק (קרדיטים לעובד) ולא ניתנת לעריכה כאן.',
  'profile.field.notSet': 'לא הוגדר',
  'profile.vehicles.title': 'רכבים',
  'profile.vehicles.optionalHint': 'אופציונלי — עד 3 רכבים. אחד מהם חייב להיות ראשי.',
  'profile.vehicles.empty': 'עדיין לא נוספו רכבים.',
  'profile.vehicles.noneOnFile': 'אין רכבים בפרופיל.',
  'profile.vehicles.add': 'הוסף רכב',
  'profile.vehicles.remove': 'הסר',
  'profile.vehicles.carN': 'רכב {n}',
  'profile.vehicles.manufacturer': 'יצרן',
  'profile.vehicles.model': 'דגם',
  'profile.vehicles.color': 'צבע',
  'profile.vehicles.licenseNumber': 'מספר רישוי',
  'profile.vehicles.licensePlaceholder': 'ספרות בלבד',
  'profile.vehicles.primary': 'ראשי',
  'profile.vehicles.setPrimary': 'רכב ראשי',
  'profile.vehicles.maxReached': 'ניתן לשמור עד 3 רכבים.',
  'profile.vehicles.errorMax': 'ניתן להוסיף עד 3 רכבים.',
  'profile.vehicles.errorIncomplete': 'מלאו יצרן, דגם, צבע ומספר רישוי לכל רכב.',
  'profile.vehicles.errorLicense': 'מספר רישוי חייב להיות 5–8 ספרות (ישראל).',
  'profile.vehicles.errorDuplicateLicense': 'לכל רכב נדרש מספר רישוי ייחודי.',
  'profile.vehicles.errorPrimary': 'בחרו רכב ראשי אחד.',
  'profile.edit.save': 'שמור שינויים',
  'profile.hub.changePhoto': 'שנה תמונת פרופיל',
  'profile.hub.changePhotoAria': 'הוסף או החלף תמונת פרופיל',
  'profile.hub.cropTitle': 'חיתוך תמונת פרופיל',
  'profile.hub.cropZoom': 'זום',
  'profile.hub.cropSave': 'השתמש בתמונה',
  'profile.hub.cropCancel': 'ביטול',
  'profile.apiLabel': 'ממשק פרופיל',
  'profile.signInToUse': 'התחבר/י כדי להשתמש בכלי הפרופיל.',
  'profile.operation.getProfile': 'הפרופיל שלי',
  'profile.operation.listWorkers': 'רשימת עובדים',
  'profile.operation.registerWorker': 'רישום עובד עסקי',
  'profile.operation.patchProfile': 'עדכון פרופיל',
  'profile.operation.changePassword': 'שינוי סיסמה',
  'profile.operation.deactivate': 'השבתת חשבון',
  'profile.failureRegion': 'מדוע בקשת הפרופיל נכשלה',
  'profile.signedInAs': 'מחובר/ת כ{name}',
  'profile.signedInAsWithType': 'מחובר/ת כ{name} · {type}',
  'profile.signInBanner': 'התחבר/י כדי להשתמש בפרופיל.',
  'profile.operationLabel': 'פעולה',
  'profile.oldPassword': 'סיסמה ישנה',
  'profile.currentPassword': 'סיסמה נוכחית',
  'profile.newPassword': 'סיסמה חדשה',
  'profile.confirmNewPassword': 'אימות סיסמה חדשה',
  'profile.passwordMismatch': 'חייבת להתאים לסיסמה החדשה למעלה.',
  'profile.passwordChangeOptional': 'אופציונלי — השאירו ריק כדי לשמור על הסיסמה הנוכחית.',
  'profile.passwordAllFieldsRequired': 'יש למלא סיסמה נוכחית, סיסמה חדשה ואימות.',
  'profile.signInToRun': 'התחבר/י כדי להריץ פעולות פרופיל.',
  'profile.businessClientWorkers': 'התחבר/י כלקוח עסקי כדי לרשום עובדים.',
  'profile.businessWorkers.title': 'עובדי העסק',
  'profile.businessWorkers.listIntro':
    'עובדים המשויכים לחשבון העסק שלך. לחץ/י על עובד לצפייה בפרטים ולניהול קרדיטים.',
  'profile.businessWorkers.empty': 'אין עובדים פעילים עדיין.',
  'profile.businessWorkers.backToList': 'חזרה לרשימת עובדים',
  'profile.businessWorkers.creditsShort': '{amount} קרדיטים',
  'profile.businessWorkers.editCredits': 'עריכת קרדיטים זמינים',
  'profile.businessWorkers.editCreditsTitle': 'קרדיטי מעסיק',
  'profile.businessWorkers.updateCredits': 'עדכון קרדיטי עובד',
  'profile.businessWorkers.creditsUpdated': 'קרדיטי העובד עודכנו.',
  'profile.businessWorkers.errorInvalidCredits': 'יש להזין סכום קרדיט תקין (0 ומעלה).',
  'profile.businessWorkers.changePhoto': 'שנה תמונת עובד',
  'profile.businessWorkers.changePhotoAria': 'הוסף או החלף תמונת פרופיל של עובד',
  'profile.businessWorkers.updatePhoto': 'עדכון תמונת עובד',
  'profile.businessWorkers.photoUpdated': 'תמונת העובד עודכנה.',
  'profile.showWorkers': 'הצגת עובדים',
  'profile.workersActiveOnly': 'פעילים בלבד',
  'profile.workersAll': 'כל העובדים',
  'profile.response': 'תגובה',
  'profile.whyFailed': 'מדוע נכשל',
  'profile.details': 'פרטים',
  'profile.defaultTitle': 'פרופיל',
  'profile.emptyResponse': 'תגובה ריקה.',
  'profile.noWorkers': 'אין עובדים התואמים לתצוגה זו.',
  'profile.updateWorker': 'עדכון עובד',
  'profile.rawJson': 'JSON גולמי',
  'profile.submit.saveProfile': 'שמירת פרופיל',
  'profile.worker.updated': 'העובד עודכן.',
  'profile.worker.deactivated': 'העובד הושבת.',
  'profile.worker.reactivated': 'העובד הופעל מחדש.',
  'profile.worker.saving': 'שומר…',
  'profile.worker.reactivating': 'מפעיל מחדש…',
  'profile.worker.deactivating': 'משבית…',
  'profile.worker.reactivate': 'הפעלה מחדש',
  'profile.worker.deactivate': 'השבתה',
  'profile.status.active': 'פעיל',
  'profile.status.inactive': 'לא פעיל',
  'profile.gender.male': 'זכר',
  'profile.gender.female': 'נקבה',
  'profile.gender.other': 'אחר',
  'profile.gender.select': 'בחר/י מגדר…',

  'assetField.id': 'מזהה',
  'assetField.assetId': 'מזהה נכס',
  'assetField.assetName': 'שם הנכס',
  'assetField.name': 'שם',
  'assetField.facilityName': 'שם מתקן',
  'assetField.description': 'תיאור',
  'assetField.subTitle': 'כותרת משנה',
  'assetField.email': 'דוא״ל',
  'assetField.phoneNumber': 'טלפון',
  'assetField.phoneNumber2': 'טלפון נוסף',
  'assetField.phone': 'טלפון',
  'assetField.registrationDate': 'תאריך רישום',
  'assetField.registeredAt': 'נרשם ב',
  'assetField.createdAt': 'נוצר ב',
  'assetField.updatedAt': 'עודכן ב',
  'assetField.deletedAt': 'נמחק ב',
  'assetField.stateId': 'אזור',
  'assetField.countryId': 'מדינה',
  'assetField.regionId': 'אזור',
  'assetField.districtId': 'מחוז',
  'assetField.assetTypeId': 'סוג נכס',
  'assetField.assetTypeName': 'סוג נכס',
  'assetField.assetStatus': 'סטטוס נכס',
  'assetField.avgRating': 'דירוג ממוצע',
  'assetField.averageRating': 'דירוג ממוצע',
  'assetField.reviewsCount': 'מספר ביקורות',
  'assetField.reviewCount': 'מספר ביקורות',
  'assetField.countryName': 'מדינה',
  'assetField.stateName': 'מחוז / נפה',
  'assetField.regionName': 'אזור',
  'assetField.districtName': 'מחוז',
  'assetField.pricingTypeName': 'סוג תמחור',
  'assetField.facilityTypeName': 'סוג מתקן',
  'assetField.typeName': 'סוג',
  'assetField.latitude': 'קו רוחב',
  'assetField.longitude': 'קו אורך',
  'assetField.minCapacity': 'קיבולת מינימלית',
  'assetField.maxCapacity': 'קיבולת מקסימלית',
  'assetField.capacity': 'קיבולת',
  'assetField.street': 'רחוב',
  'assetField.streetNumber': 'מספר בית',
  'assetField.houseNumber': 'מספר בית',
  'assetField.city': 'עיר',
  'assetField.zipCode': 'מיקוד',
  'assetField.postalCode': 'מיקוד',
  'assetField.zip': 'מיקוד',
  'assetField.state': 'מדינה',
  'assetField.country': 'מדינה',
  'assetField.address': 'כתובת',
  'assetField.addressLine1': 'שורת כתובת 1',
  'assetField.addressLine2': 'שורת כתובת 2',
  'assetField.addressAdditional': 'מידע נוסף',
  'assetField.isVerifiedPhone': 'טלפון מאומת',
  'assetField.isVerifiedEmail': 'דוא״ל מאומת',
  'assetField.building': 'בניין',
  'assetField.floor': 'קומה',
  'assetField.apartment': 'דירה',
  'assetField.price': 'מחיר',
  'assetField.unitPrice': 'מחיר ליחידה',
  'assetField.amount': 'סכום',
  'assetField.cost': 'עלות',
  'assetField.rate': 'תעריף',
  'assetField.fee': 'עמלה',
  'assetField.addonPrice': 'מחיר תוספת',
  'assetField.availableQuantity': 'כמות זמינה',
  'assetField.quantity': 'כמות',
  'assetField.pricingTypeId': 'סוג תמחור',
  'assetField.pricingType': 'סוג תמחור',
  'assetField.facilityId': 'מתקן',
  'assetField.addonId': 'תוספת',
  'assetField.facilityTypeId': 'סוג מתקן',
  'assetField.addonName': 'שם תוספת',
  'assetField.title': 'כותרת',
  'assetField.label': 'תווית',
  'assetField.status': 'סטטוס',
  'assetField.active': 'פעיל',
  'assetField.published': 'מפורסם',
  'assetField.ownerId': 'בעלים',
  'assetField.userId': 'משתמש',
  'assetField.workerId': 'מזהה עובד',
  'assetField.firstName': 'שם פרטי',
  'assetField.lastName': 'שם משפחה',
  'assetField.businessName': 'שם העסק',
  'assetField.businessType': 'סוג עסק',
  'assetField.isBusiness': 'עסק',
  'assetField.businessId': 'ח.פ.',
  'assetField.creditsPerEmployee': 'קרדיטים לעובד',
  'assetField.credits': 'קרדיטים',
  'assetField.nationalId': 'תעודת זהות',
  'assetField.birthDate': 'תאריך לידה',
  'assetField.gender': 'מגדר',
  'assetField.position': 'תפקיד',
  'assetField.roleId': 'תפקיד במערכת',
  'assetField.isActive': 'פעיל',
  'assetField.workerStatus': 'סטטוס עובד',
  'assetField.employmentStatus': 'סטטוס העסקה',
  'assetField.password': 'סיסמה',
  'assetField.confirmPassword': 'אימות סיסמה',
  'assetField.oldPassword': 'סיסמה ישנה',
  'assetField.newPassword': 'סיסמה חדשה',
  'assetField.images': 'תמונות',
  'assetField.openingTimes': 'שעות פתיחה',
  'assetField.facilities': 'מתקנים',
  'assetField.pricingMethods': 'שיטות תמחור',
  'assetField.addons': 'תוספות',
  'assetField.currency': 'מטבע',
  'assetField.vat': 'מע״מ',
  'assetField.tax': 'מס',
  'assetField.notes': 'הערות',
  'assetField.website': 'אתר',
  'assetField.url': 'כתובת URL',

  'weekday.sunday': 'ראשון',
  'weekday.monday': 'שני',
  'weekday.tuesday': 'שלישי',
  'weekday.wednesday': 'רביעי',
  'weekday.thursday': 'חמישי',
  'weekday.friday': 'שישי',
  'weekday.saturday': 'שבת',

  'openingTimes.weekdaysSection': 'ימי חול',
  'openingTimes.fridaySection': 'שישי',
  'openingTimes.saturdaySection': 'שבת',
  'openingTimes.sundaySection': 'ראשון',
  'openingTimes.weekendSection': 'סוף שבוע',
  'openingTimes.setOpenHours': 'הגדר שעות פתיחה',
  'openingTimes.open': 'פתיחה',
  'openingTimes.close': 'סגירה',
  'openingTimes.openAllDay': 'פתוח כל היום',
  'openingTimes.setClosed': 'סגור ביום זה',
  'openingTimes.allDayHint': 'נשלח כיום מלא ({open}–{close}).',
  'openingTimes.specificDates': 'תאריכים מיוחדים',
  'openingTimes.hideList': 'הסתר רשימה',
  'openingTimes.showList': 'הצג רשימה ({count})',
  'openingTimes.specificDatesHint': 'בחרו תאריך מהיום והלאה (יום, חודש, שנה).',
  'openingTimes.addSpecificDate': 'הוסף תאריך',
  'openingTimes.noSpecialDatesYet': 'אין תאריכים מיוחדים עדיין.',
  'openingTimes.selectSpecificDate': 'בחרו תאריך…',
  'openingTimes.blackoutDates': 'תאריכי חסימה',
  'openingTimes.blackoutDatesHint':
    'בחרו תאריך התחלה, ואז הגדירו מספר ימים או תאריך סיום. השדה השני מתעדכן אוטומטית.',
  'openingTimes.blackoutStart': 'תאריך התחלה',
  'openingTimes.blackoutDays': 'מספר ימים',
  'openingTimes.blackoutEnd': 'תאריך סיום',
  'openingTimes.addBlackoutDates': 'הוסף תאריכי חסימה',
  'openingTimes.noBlackoutDatesYet': 'אין תאריכי חסימה עדיין.',
  'openingTimes.blackoutRangesListHint': 'טווחי חסימה שמורים. הרחיבו טווח כדי לשנות תאריכים או להסיר.',
  'openingTimes.blackoutRangeDays': '{n} ימים',
  'openingTimes.saveBlackoutRange': 'שמירת טווח',
  'openingTimes.removeBlackoutRange': 'הסרת טווח',
  'openingTimes.blackoutPickStart': 'בחרו תאריך התחלה תחילה.',
  'openingTimes.blackoutInvalidRange': 'תאריך הסיום חייב להיות באותו יום או אחרי תאריך ההתחלה.',
  'openingTimes.remove': 'הסר',
  'openingTimes.dayOverrides': 'שעות שונות לפי יום',
  'openingTimes.removeDayOverride': 'חזור לשעות הקבוצה',
  'openingTimes.addDay': 'הוסף יום',
  'openingTimes.addDayHint': 'השתמשו בזה כשיום חול בודד צריך שעות שונות מההגדרה המשותפת למעלה.',
  'openingTimes.customizeDaysMenu': 'התאמת יום חול בודד',
  'openingTimes.expandAllWeekdays': 'הגדרת כל ימי החול בנפרד',
  'openingTimes.selectDay': 'בחרו יום…',
  'openingTimes.pickDateFirst': 'בחרו יום, חודש ושנה תחילה.',
  'openingTimes.pickDateThenAdd': 'בחרו יום, חודש ושנה ואז לחצו הוסף.',
  'openingTimes.dateMustBeFuture': 'בחרו תאריך מהיום והלאה.',
  'openingTimes.dateAlreadyExists': '«{date}» כבר קיים בשעות הפתיחה.',

  'assetDetail.asset': 'נכס',
  'assetDetail.address': 'כתובת',
  'assetDetail.openingTimes': 'שעות פתיחה',
  'assetDetail.daysOfWeek': 'ימי השבוע',
  'assetDetail.dateOverrides': 'חריגות תאריך',
  'assetDetail.day': 'יום',
  'assetDetail.allDays': 'כל הימים',
  'assetDetail.hours': 'שעות',
  'assetDetail.closed': 'סגור',
  'assetDetail.open24h': 'פתוח 24 שעות',
  'assetDetail.description': 'תיאור',
  'assetDetail.details': 'פרטים',
  'assetDetail.capacity': 'קיבולת',
  'assetDetail.facilitiesAddons': 'מתקנים',
  'assetDetail.pricing': 'תמחור',
  'assetDetail.images': 'תמונות',
  'assetDetail.assetImages': 'תמונות נכס',
  'assetDetail.imageNotAvailable': 'תמונה לא זמינה',
  'assetDetail.type': 'סוג',
  'assetDetail.item': 'פריט',
  'assetDetail.facility': 'מתקן',
  'assetDetail.addon': 'תוספת',
  'assetDetail.imagesWireError':
    'לנכס זה יש שדה תמונות, אך לא ניתן לקרוא כתובת או נתיב שמיש מהרשומות. כל פריט צריך להיות מחרוזת נתיב/URL או אובייקט עם url, src, image_url או path. אם ההעלאות נשמרות רק בדיסק, ה-API חייב לחשוף URL או נתיב אינטרנט.',
  'assetDetail.specificDates': 'תאריכים מיוחדים ({count})',
  'assetDetail.imageNumber': 'תמונה {index}',
  'assetDetail.viewLarger': 'הצג תמונה גדולה',
  'assetDetail.closeLightbox': 'סגור',

  'assetProfile.about': 'קצת על המועדון',
  'assetProfile.listingInfo': 'פרטי הרישום',
  'assetProfile.listingDate': 'תאריך פרסום',
  'assetProfile.ratingAndReviews': 'דירוג וביקורות',
  'assetProfile.ratingSummary': '{rating} · {count} ביקורות',
  'assetProfile.noReviewsYet': 'אין ביקורות עדיין',
  'assetProfile.reviews': 'ביקורות',
  'assetProfile.reviewsRecent': 'אחרונות',
  'assetProfile.reviewsAll': 'הכל',
  'assetProfile.reviewsChoice': 'ביקורות נבחרות',
  'assetProfile.reviewsComingSoon': 'ביקורות יוצגו כאן בקרוב.',
  'assetProfile.pricingHourly': 'לשעה',
  'assetProfile.pricingDaily': 'ליום',
  'assetProfile.pricingMonthly': 'לחודש',
  'assetProfile.pricesExcludeVat': "המחירים לא כוללים מע''מ",
  'assetProfile.priceNotSet': 'לא הוגדר',
  'assetProfile.share': 'שיתוף',
  'assetProfile.call': 'התקשרות',
  'assetProfile.whatsapp': 'WhatsApp',
  'assetProfile.email': 'דוא"ל',
  'assetProfile.emailGmail': 'Gmail',
  'assetProfile.emailApp': 'אפליקציית דוא"ל',
  'assetProfile.navigate': 'ניווט',
  'assetProfile.distance': '{distance} ממך',
  'assetProfile.totalFrom': 'סה"כ: {price}',
  'assetProfile.carouselPrev': 'תמונה קודמת',
  'assetProfile.carouselNext': 'תמונה הבאה',

  'quickBooking.title': 'הזמנה',
  'quickBooking.modeLabel': 'סוג הזמנה',
  'quickBooking.modeHour': 'לשעה',
  'quickBooking.modeDay': 'ליום',
  'quickBooking.modeMonth': 'לחודש',
  'quickBooking.selectDate': 'בחרו תאריך',
  'quickBooking.dayColumn': 'יום',
  'quickBooking.monthColumn': 'חודש',
  'quickBooking.yearColumn': 'שנה',
  'quickBooking.openCalendar': 'פתיחת לוח שנה',
  'quickBooking.entryTime': 'שעת כניסה',
  'quickBooking.exitTime': 'שעת יציאה',
  'quickBooking.totalHours': 'סה"כ שעות',
  'quickBooking.totalDays': 'מספר ימים',
  'quickBooking.totalMonths': 'מספר חודשים',
  'quickBooking.people': 'מס׳ אנשים',
  'quickBooking.peopleAvailable': 'זמין לתאריכים אלה: {capacity}',
  'quickBooking.totalToPay': 'סה״כ לתשלום:',
  'quickBooking.pricePending': '—',
  'quickBooking.proceedToPayment': 'מעבר לתשלום',
  'quickBooking.errorHours': 'בחרו טווח שעות תקין (שעות שלמות בלבד).',
  'quickBooking.errorClosedHours': 'הנכס סגור בחלק מהשעות שנבחרו.',
  'quickBooking.errorClosedDay': 'הנכס סגור באחד או יותר מהימים שנבחרו.',
  'quickBooking.errorClosedMonth': 'הנכס סגור באחד או יותר מהימים בחודשים שנבחרו.',
  'quickBooking.errorFullyBooked': 'אין זמינות להזמנה בתאריך שנבחר.',

  'list.listedAssets': 'נכסים ברשימה',
  'list.assetType': 'סוג נכס',
  'list.view': 'צפייה',
  'list.viewAsset': 'צפייה ב{title}',
  'list.edit': 'עריכה',
  'list.editAsset': 'עריכת {title}',
  'list.cannotEditNoId': 'לא ניתן לערוך את {title} (חסר מזהה)',
  'list.cannotEditNotOwner': 'לא ניתן לערוך את {title} (לא הנכס שלך)',
  'list.ownerOnlyEdit': 'רק הבעלים הרשום יכול לערוך נכס זה.',
  'list.distanceAria': 'מרחק מהמיקום שלך: {distance}',
  'list.book': 'הזמן',
  'list.cannotBookSignIn': 'לא ניתן להזמין את {title} (נדרשת התחברות)',
  'list.cannotBookNoId': 'לא ניתן להזמין את {title} (חסר מזהה)',
  'list.bookAsset': 'הזמן את {title}',
  'list.cannotDeleteNoId': 'לא ניתן למחוק את {title} (חסר מזהה)',
  'list.cannotDeleteNotOwner': 'לא ניתן למחוק את {title} (לא הנכס שלך)',
  'list.deleteAsset': 'מחק את {title}',
  'list.ownerOnlyDelete': 'רק הבעלים הרשום יכול למחוק נכס זה.',
  'list.imagesNotice': 'שדה תמונות קיים אך לא ניתן לקרוא נתיבים — בדוק/י מבנה API או כתובות.',

  'connection.title': 'בדיקת חיבור',
  'connection.runCheck': 'הרץ בדיקת חיבור',
  'connection.checking': 'בודק…',
  'connection.tokenStatus': 'סטטוס אסימון Bearer',
  'connection.apiTest': 'בדיקת חיבור API',
  'connection.notificationsTest': 'התראות — בדיקת חיבור',

  'form.closed': 'סגור',
  'form.openingDate': 'תאריך ספציפי לשעות פתיחה',
  'form.notOnPatch': 'לא מוחל ב-PATCH עבור נקודת קצה זו',
  'form.notSentPatch': 'לא נשלח ב-PATCH — השדה הושמט או לא נתמך',
  'form.notSentPatchNested': 'לא נשלח ב-PATCH — הושמט או מטען תצוגה מקונן בלבד',
};

const _missing: MessageKey[] = (Object.keys(en) as MessageKey[]).filter((k) => !(k in he));
if (_missing.length > 0 && process.env.NODE_ENV !== 'production') {
  console.warn('[i18n] Missing Hebrew translations:', _missing.join(', '));
}
